// ------------------------------
// SIMULATOR
// ------------------------------
$(document).ready(function () {

    // STEP01
    // サービスご利用状況を選択してください。
    $('input[type="radio"][name="step1"]').on('change', function () {
        $left_id = "2";
        $right_id = "2";


        switch ($(this).val()) {
            case 'ご検討のお客さま':
                hideQuestions(0);
                $("#step" + $left_id).addClass("step-active");
                $(".new-type").addClass("step-active");
                $(".current-type").removeClass("step-active");
                break;

            case 'ご利用中のお客さま':
                hideQuestions(0);
                $("#step" + $right_id).addClass("step-active");
                $(".current-type").addClass("step-active");
                $(".new-type").removeClass("step-active");
                break;
        }

        initCurrentServices();
        clearAllLeftResults();
        setStepTitle();
    });

    // STEP02
    // 住居形態を選択してください
    $('input[type="radio"][name="step2"]').on('change', function () {
        if ($('input[type="radio"][name="step1"]:checked').val() === "ご検討のお客さま") {
            // ご検討のお客さま
            $("#step3-cur").removeClass("step-active");

            hideQuestions(1);
            showhideServices("net", "cbNet");
            showhideServices("mobile", "cbMobile");
            showhideServices("tv", "cbTv");
            showhideServices("phone", "cbPhone");
            initCampaign();
            initService("step4");
            initCurrentPrice();
            clearLeftResults();

            $("#step4").addClass("step-active");

        } else {
            // ご利用中のお客さま

            showhideServicesChange("net", "cbNet");
            showhideServicesChange("mobile", "cbMobile");
            showhideServicesChange("tv", "cbTv");
            showhideServicesChange("phone", "cbPhone");
            $("#step3-1").removeClass("step-active");
            $("#step3-2").removeClass("step-active");
            $("#step4").removeClass("step-active");

            hideQuestions(1);
            initService("step3-cur");
            $("#step3-cur").addClass("step-active");
            clearLeftResults();
        }

        setStepTitle();
    });

    // STEP03
    // ご検討のお客さま
    // 検討中のサービスを選択してください
    var campaignChangeH = function () {
        getSelectedResults();

        if ($('input[type="radio"][name="step1"]:checked').val() === "ご検討のお客さま") {
        } else {
            showSelectedResults();

        }
    };
    $(document).on('change', 'input[type="checkbox"][name="step3-1-net"], input[type="checkbox"][name="step3-1-mobile"], input[type="checkbox"][name="step3-1-tv"], input[type="checkbox"][name="step3-1-phone"]', campaignChangeH);

    var campaignChangeM = function () {
        getSelectedResults();
        if ($('input[type="radio"][name="step1"]:checked').val() === "ご検討のお客さま") {
        } else {
            showSelectedResults();

        }

    };
    $(document).on('change', 'input[type="checkbox"][name="step3-2-net"], input[type="checkbox"][name="step3-2-mobile"], input[type="checkbox"][name="step3-2-tv"], input[type="checkbox"][name="step3-2-phone"]', campaignChangeM);

    var campaignOthersChangeH = function () {
        getSelectedResults();
        if ($('input[type="radio"][name="step1"]:checked').val() === "ご検討のお客さま") {
        } else {
            showSelectedResults();

        }
    };
    $(document).on('change', 'input[type="checkbox"][name="step3-1-cb-net"], input[type="checkbox"][name="step3-1-cb-mobile"], input[type="checkbox"][name="step3-1-cb-tv"], input[type="checkbox"][name="step3-1-cb-phone"]', campaignOthersChangeH);

    var campaignOthersChangeM = function () {
        getSelectedResults();
        if ($('input[type="radio"][name="step1"]:checked').val() === "ご検討のお客さま") {
        } else {
            showSelectedResults();

        }

    };
    $(document).on('change', 'input[type="checkbox"][name="step3-2-cb-net"], input[type="checkbox"][name="step3-2-cb-mobile"], input[type="checkbox"][name="step3-2-cb-tv"], input[type="checkbox"][name="step3-2-cb-phone"]', campaignOthersChangeM);


    // STEP04
    // ご検討のお客さま
    // サービスのコースを選択してください
    $('input[type="checkbox"][name="step4"]').on('change', function () {
        if ($('input[type="checkbox"][name="step4"]:checked').length === 0) {
            hideQuestions(3);
            hideQuestions(4);
            initCurrentPrice();
            $("#step5").removeClass("step-active");
            $("#step-res1").removeClass("step-active");
            initCampaignByServices();
            $('.row-mobileoption').removeClass('active-row');
        } else {
            hideQuestions(3);
            hideQuestions(4);
            $("#step6").addClass("step-active");

            showCampaignByServices();
            initCampaignByServices();

            if ($('.cbMobile').is(':checked')) {
                $('.row-mobileoption').addClass('active-row');
            } else {
                $('.row-mobileoption').removeClass('active-row');
            }
        }

        showhideServices("net", "cbNet");
        showhideServices("mobile", "cbMobile");
        showhideServices("tv", "cbTv");
        showhideServices("phone", "cbPhone");

        calcTotalByMonth();
        calcTotalByYear();

        clearLeftResults();
        $('.res-campaign').hide();

        setMobileOptionDefault('step');
    });

    // STEP03-CUR
    // ご利用中のお客さま
    // 現在ご加入のサービスを選択してください
    $('input[type="checkbox"][name="step3-cur"]').on('change', function () {
        if ($('input[type="checkbox"][name="step3-cur"]:checked').length === 0) {
            hideQuestions(2);
            hideQuestions(3);
            $('.not-selected-plan').show();
            $('.row-mobileoption').removeClass('active-row');

        } else {
            $("#step4-cur").addClass("step-active");
            hideQuestions(3);
            hideQuestions(4);
            initService("step5-cur");
            if ($('#cbMobile-cur').is(':checked')) {
                $('.row-mobileoption').addClass('active-row');
            } else {
                $('.not-selected-plan').show();
                $('.row-mobileoption').removeClass('active-row');
            }
        }

        showhideServicesChange("net", "cbNet");
        showhideServicesChange("mobile", "cbMobile");
        showhideServicesChange("tv", "cbTv");
        showhideServicesChange("phone", "cbPhone");

        calcTotalByMonthChange();

        showSelectedResults();

        clearAllLeftResults();
        setStepTitle();
        $('.res-campaign').hide();

    });

    // STEP06・STEP04-CUR
    // 戸建住宅
    $('input[type="radio"][name="step-net-h"]').on('change', function () {
        if ($('input[type="radio"][name="step1"]:checked').val() === "ご検討のお客さま") {
            // ご検討のお客さま
            if ($('.cbNet').is(':checked')) {

                setLeftResults('net');

                var campaigns = $(this).data('campaigns');
                var cashbacks = $(this).data('cashbacks');
                if (campaigns) {
                    getCampaignByService(campaigns, cashbacks, 'net');
                    showCampaignByServices();


                    $left_id = "3-1";
                    $right_id = "3-2";
                    switch ($('input[type="radio"][name="step2"]:checked').val()) {
                        case '戸建住宅':
                            $("#step" + $right_id).removeClass("step-active");
                            $("#step" + $left_id).addClass("step-active");

                            break;

                        case '集合住宅':
                            $("#step" + $left_id).removeClass("step-active");
                            $("#step" + $right_id).addClass("step-active");
                            break;
                    }
                }

                $('#step-res1').addClass('step-active');
                getSelectedResults();

            } else {
                $('.selected-plan-net').text('－');
            }
            calcTotalByMonth();

        } else {
            // ご利用中のお客さま
            $("#step5-cur").addClass("step-active");
            initOptionNew();
            bringUnselectedOptions();
            calcTotalByMonth();
            calcTotalByMonthChange();

            if ($('.cbNet').is(':checked')) {
                $('.not-selected-plan').hide();
                setLeftResults('net');
            } else {
                $('.selected-plan-net').text('');
            }

            showSelectedResults();


        }

        setLeftCampaign();
    });

    $('input[type="radio"][name="step-mobile-h"]').on('change', function () {
        if ($('input[type="radio"][name="step1"]:checked').val() === "ご検討のお客さま") {
            // ご検討のお客さま
            if ($('.cbMobile').is(':checked')) {
                setLeftResults('mobile');

                var campaigns = $(this).data('campaigns');
                var cashbacks = $(this).data('cashbacks');
                if (campaigns) {
                    getCampaignByService(campaigns, cashbacks, 'mobile');

                    $left_id = "3-1";
                    $right_id = "3-2";

                    switch ($('input[type="radio"][name="step2"]:checked').val()) {
                        case '戸建住宅':
                            $("#step" + $right_id).removeClass("step-active");
                            $("#step" + $left_id).addClass("step-active");
                            break;

                        case '集合住宅':
                            $("#step" + $left_id).removeClass("step-active");
                            $("#step" + $right_id).addClass("step-active");
                            break;
                    }
                }

                $('#step-res1').addClass('step-active');
                getSelectedResults();


            } else {
                $('.selected-plan-mobile').text('－');
            }
            calcTotalByMonth();
            // calcTotalByYear();
            // calcDiff();

        } else {
            // ご利用中のお客さま
            $("#step5-cur").addClass("step-active");
            initOptionNew();
            bringUnselectedOptions();
            calcTotalByMonth();
            calcTotalByMonthChange();

            if ($('.cbMobile').is(':checked')) {
                $('.not-selected-plan').hide();

                setLeftResults('mobile');
            } else {
                $('.selected-plan-mobile').text('');
            }

            showSelectedResults();
        }

        setLeftCampaign();
    });

    $('input[type="radio"][name="step-mobileoption-h"]').on('change', function () {
        if ($('input[type="radio"][name="step1"]:checked').val() === "ご検討のお客さま") {
            // ご検討のお客さま

            calcTotalByMonth();

            setLeftResults('mobileoption');

            if ($('.cbMobile').is(':checked')) {
                setLeftResults('mobileoption');
                $('.row-mobileoption').addClass('active-row');
            } else {
                $('.selected-plan-mobileoption').text('－');
                $('.row-mobileoption').removeClass('active-row');
            }

            getSelectedResults();

        } else {
            $("#step5-cur").addClass("step-active");
            initOptionNew();
            bringUnselectedOptions();
            calcTotalByMonth();
            calcTotalByMonthChange();

            showSelectedResults();

            if ($('.cbMobile').is(':checked')) {
                setLeftResults('mobileoption');
            }
        }
        $('.changed-plan-mobileoption').text('');
        setLeftCampaign();
        calcTotalByMonth();
        calcTotalByMonthChange();
    });

    $('input[type="radio"][name="step-tv-h"]').on('change', function () {
        if ($('input[type="radio"][name="step1"]:checked').val() === "ご検討のお客さま") {
            // ご検討のお客さま
            if ($('.cbTv').is(':checked')) {
                setLeftResults('tv');

                var campaigns = $(this).data('campaigns');
                var cashbacks = $(this).data('cashbacks');

                if (campaigns) {
                    getCampaignByService(campaigns, cashbacks, 'tv');


                    $left_id = "3-1";
                    $right_id = "3-2";
                    switch ($('input[type="radio"][name="step2"]:checked').val()) {
                        case '戸建住宅':
                            $("#step" + $right_id).removeClass("step-active");
                            $("#step" + $left_id).addClass("step-active");
                            break;

                        case '集合住宅':
                            $("#step" + $left_id).removeClass("step-active");
                            $("#step" + $right_id).addClass("step-active");
                            break;
                    }
                }

                $('#step-res1').addClass('step-active');
                getSelectedResults();

            } else {
                $('.selected-plan-tv').text('－');
            }
            calcTotalByMonth();
            // calcTotalByYear();
            // calcDiff();
        } else {
            // ご利用中のお客さま
            $("#step5-cur").addClass("step-active");
            initOptionNew();
            bringUnselectedOptions();
            calcTotalByMonth();
            calcTotalByMonthChange();

            if ($('.cbTv').is(':checked')) {
                $('.not-selected-plan').hide();
                setLeftResults('tv');
            } else {
                $('.selected-plan-tv').text('');
            }

            showSelectedResults();
        }

        setLeftCampaign();
    });

    $('input[type="radio"][name="step-phone-h"]').on('change', function () {
        if ($('input[type="radio"][name="step1"]:checked').val() === "ご検討のお客さま") {
            // ご検討のお客さま
            if ($('.cbPhone').is(':checked')) {
                setLeftResults('phone');

                var campaigns = $(this).data('campaigns');
                var cashbacks = $(this).data('cashbacks');

                if (campaigns) {
                    getCampaignByService(campaigns, cashbacks, 'phone');


                    $left_id = "3-1";
                    $right_id = "3-2";
                    switch ($('input[type="radio"][name="step2"]:checked').val()) {
                        case '戸建住宅':
                            $("#step" + $right_id).removeClass("step-active");
                            $("#step" + $left_id).addClass("step-active");
                            break;

                        case '集合住宅':
                            $("#step" + $left_id).removeClass("step-active");
                            $("#step" + $right_id).addClass("step-active");
                            break;
                    }
                }
                $('#step-res1').addClass('step-active');
                getSelectedResults();


            } else {
                $('.selected-plan-phone').text('－');
            }
            calcTotalByMonth();
            // calcTotalByYear();
            // calcDiff();

        } else {
            // ご利用中のお客さま
            $("#step5-cur").addClass("step-active");
            initOptionNew();
            bringUnselectedOptions();
            calcTotalByMonth();
            calcTotalByMonthChange();

            if ($('.cbPhone').is(':checked')) {
                $('.not-selected-plan').hide();
                setLeftResults('phone');
            } else {
                $('.selected-plan-phone').text('');
            }

            showSelectedResults();
        }

        setLeftCampaign();
    });

    // 集合住宅
    $('input[type="radio"][name="step-net-m"]').on('change', function () {
        if ($('input[type="radio"][name="step1"]:checked').val() === "ご検討のお客さま") {
            // ご検討のお客さま
            if ($('.cbNet').is(':checked')) {
                setLeftResults('net');

                var campaigns = $(this).data('campaigns');
                var cashbacks = $(this).data('cashbacks');

                if (campaigns) {
                    getCampaignByService(campaigns, cashbacks, 'net');

                    $left_id = "3-1";
                    $right_id = "3-2";
                    switch ($('input[type="radio"][name="step2"]:checked').val()) {
                        case '戸建住宅':
                            $("#step" + $right_id).removeClass("step-active");
                            $("#step" + $left_id).addClass("step-active");
                            break;

                        case '集合住宅':
                            $("#step" + $left_id).removeClass("step-active");
                            $("#step" + $right_id).addClass("step-active");
                            break;
                    }
                }

                $('#step-res1').addClass('step-active');
                getSelectedResults();

            } else {
                $('.selected-plan-net').text('－');
            }
            calcTotalByMonth();
            // calcTotalByYear();
            // calcDiff();
        } else {
            // ご利用中のお客さま
            $("#step5-cur").addClass("step-active");
            initOptionNew();
            bringUnselectedOptions();
            calcTotalByMonth();
            calcTotalByMonthChange();

            if ($('.cbNet').is(':checked')) {
                $('.not-selected-plan').hide();
                setLeftResults('net');
            } else {
                $('.selected-plan-net').text('');
            }

            showSelectedResults();
        }

        setLeftCampaign();
    });

    $('input[type="radio"][name="step-mobile-m"]').on('change', function () {
        if ($('input[type="radio"][name="step1"]:checked').val() === "ご検討のお客さま") {
            // ご検討のお客さま
            if ($('.cbMobile').is(':checked')) {
                setLeftResults('mobile');

                var campaigns = $(this).data('campaigns');
                var cashbacks = $(this).data('cashbacks');

                if (campaigns) {
                    getCampaignByService(campaigns, cashbacks, 'mobile');

                    $left_id = "3-1";
                    $right_id = "3-2";
                    switch ($('input[type="radio"][name="step2"]:checked').val()) {
                        case '戸建住宅':
                            $("#step" + $right_id).removeClass("step-active");
                            $("#step" + $left_id).addClass("step-active");
                            break;

                        case '集合住宅':
                            $("#step" + $left_id).removeClass("step-active");
                            $("#step" + $right_id).addClass("step-active");
                            break;
                    }
                }

                $('#step-res1').addClass('step-active');
                getSelectedResults();
            } else {
                $('.selected-plan-mobile').text('－');
            }
            calcTotalByMonth();
        } else {
            // ご利用中のお客さま
            $("#step5-cur").addClass("step-active");
            initOptionNew();
            bringUnselectedOptions();
            calcTotalByMonth();
            calcTotalByMonthChange();

            if ($('.cbMobile').is(':checked')) {
                $('.not-selected-plan').hide();
                setLeftResults('mobile');
            } else {
                $('.selected-plan-mobile').text('');
            }

            showSelectedResults();
        }

        setLeftCampaign();
    });

    $('input[type="radio"][name="step-mobileoption-m"]').on('change', function () {
        if ($('input[type="radio"][name="step1"]:checked').val() === "ご検討のお客さま") {
            // ご検討のお客さま
            calcTotalByMonth();

            if ($('.cbMobile').is(':checked')) {
                setLeftResults('mobileoption');
                $('.row-mobileoption').addClass('active-row');
            } else {
                $('.selected-plan-mobileoption').text('－');
                $('.row-mobileoption').addClass('active-row');
            }

            getSelectedResults();

        } else {
            // ご利用中のお客さま
            $("#step5-cur").addClass("step-active");
            initOptionNew();
            bringUnselectedOptions();
            calcTotalByMonth();
            calcTotalByMonthChange();

            showSelectedResults();

            if ($('.cbMobile').is(':checked')) {
                setLeftResults('mobileoption');
            }
        }

        setLeftCampaign();
    });

    $('input[type="radio"][name="step-tv-m"]').on('change', function () {
        if ($('input[type="radio"][name="step1"]:checked').val() === "ご検討のお客さま") {
            // ご検討のお客さま
            if ($('.cbTv').is(':checked')) {
                setLeftResults('tv');

                var campaigns = $(this).data('campaigns');
                var cashbacks = $(this).data('cashbacks');
                if (campaigns) {
                    getCampaignByService(campaigns, cashbacks, 'tv');

                    $left_id = "3-1";
                    $right_id = "3-2";
                    switch ($('input[type="radio"][name="step2"]:checked').val()) {
                        case '戸建住宅':
                            $("#step" + $right_id).removeClass("step-active");
                            $("#step" + $left_id).addClass("step-active");
                            break;

                        case '集合住宅':
                            $("#step" + $left_id).removeClass("step-active");
                            $("#step" + $right_id).addClass("step-active");
                            break;
                    }
                }

                $('#step-res1').addClass('step-active');
                getSelectedResults();
            } else {
                $('.selected-plan-tv').text('－');
            }
            calcTotalByMonth();
        } else {
            // ご利用中のお客さま
            $("#step5-cur").addClass("step-active");
            initOptionNew();
            bringUnselectedOptions();
            calcTotalByMonth();
            calcTotalByMonthChange();

            if ($('.cbTv').is(':checked')) {
                $('.not-selected-plan').hide();
                setLeftResults('tv');
            } else {
                $('.selected-plan-tv').text('');
            }

            showSelectedResults();
        }

        setLeftCampaign();
    });

    $('input[type="radio"][name="step-phone-m"]').on('change', function () {
        if ($('input[type="radio"][name="step1"]:checked').val() === "ご検討のお客さま") {
            // ご検討のお客さま
            if ($('.cbPhone').is(':checked')) {
                setLeftResults('phone');

                var campaigns = $(this).data('campaigns');
                var cashbacks = $(this).data('cashbacks');
                if (campaigns) {
                    getCampaignByService(campaigns, cashbacks, 'phone');

                    $left_id = "3-1";
                    $right_id = "3-2";
                    switch ($('input[type="radio"][name="step2"]:checked').val()) {
                        case '戸建住宅':
                            $("#step" + $right_id).removeClass("step-active");
                            $("#step" + $left_id).addClass("step-active");
                            break;

                        case '集合住宅':
                            $("#step" + $left_id).removeClass("step-active");
                            $("#step" + $right_id).addClass("step-active");
                            break;
                    }
                }

                $('#step-res1').addClass('step-active');
                getSelectedResults();
            } else {
                $('.selected-plan-phone').text('－');
            }
            calcTotalByMonth();
            // calcTotalByYear();
            // calcDiff();
        } else {
            // ご利用中のお客さま
            $("#step5-cur").addClass("step-active");
            initOptionNew();
            bringUnselectedOptions();
            calcTotalByMonth();
            calcTotalByMonthChange();

            if ($('.cbPhone').is(':checked')) {
                $('.not-selected-plan').hide();
                setLeftResults('phone');
            } else {
                $('.selected-plan-phone').text('');
            }

            showSelectedResults();
        }

        setLeftCampaign();
    });

    // STEP05-CUR
    // ご利用中のお客さま
    // 追加/変更ご検討のサービスを選択してください
    $('input[type="checkbox"][name="step5-cur"]').on('change', function () {
        getSelectedResults();
        if ($('input[type="checkbox"][name="step5-cur"]:checked').length === 0) {
            hideQuestions(3);
            initTableResults();
            $('.row-mobileoption-change').removeClass('active-row');

        } else {
            hideQuestions(3);
            // hideQuestions(4);
            initTableResults();
            verifySelectedServices();

            setStepTitle();

            showCampaignByServices();
            initCampaignByServices();

            if ($('#cbMobile-cur').is(':checked')) {
                if ($('#cbMobile-cur2').is(':checked')) {
                    $('.row-mobileoption-new').removeClass('active-row');
                    $('.row-mobileoption-change').addClass('active-row');
                } else {
                    $('.row-mobileoption-new').addClass('active-row');
                    $('.row-mobileoption-change').removeClass('active-row');
                }
            } else {
                if ($('#cbMobile-cur2').is(':checked')) {
                    $('.row-mobileoption-new').removeClass('active-row');
                    $('.row-mobileoption-change').addClass('active-row');
                } else {
                    $('.row-mobileoption-new').removeClass('active-row');
                    $('.row-mobileoption-change').removeClass('active-row');
                }
            }

        }

        initOptionChange();
        bringUnselectedOptions();

        showhideServicesChange("net", "cbNet");
        showhideServicesChange("mobile", "cbMobile");
        showhideServicesChange("tv", "cbTv");
        showhideServicesChange("phone", "cbPhone");

        calcTotalByMonthChange();

        showSelectedResults();
        $('.res-campaign').hide();

        if (!$('#cbMobile-cur').is(':checked')) {
            setMobileOptionDefault('stepcur');
        }
    });


    // STEP06-CUR
    // 戸建住宅
    $('input[type="radio"][name="stepcur-net-h"]').on('change', function () {
        // ご利用中のお客さま
        calcTotalByMonthChange();

        if ($('#cbNet-cur2').is(':checked')) {
            $('.not-changed-plan').hide();
            setLeftResultsChange('net', 'stepcur');

            var campaigns = $(this).data('campaigns');
            var cashbacks = $(this).data('cashbacks');
            if (campaigns) {

                getCampaignByService(campaigns, cashbacks, 'net');

                $left_id = "3-1";
                $right_id = "3-2";
                switch ($('input[type="radio"][name="step2"]:checked').val()) {
                    case '戸建住宅':
                        $("#step" + $right_id).removeClass("step-active");
                        $("#step" + $left_id).addClass("step-active");

                        break;

                    case '集合住宅':
                        $("#step" + $left_id).removeClass("step-active");
                        $("#step" + $right_id).addClass("step-active");
                        break;
                }

                getSelectedResults();
            }
        } else {
            $('.changed-plan-net').text('');
        }

        $('#step-res3').addClass('step-active');

        showSelectedResults();
    });

    $('input[type="radio"][name="stepcur-mobile-h"]').on('change', function () {
        // ご利用中のお客さま
        calcTotalByMonthChange();

        if ($('#cbMobile-cur2').is(':checked')) {
            $('.not-changed-plan').hide();
            setLeftResultsChange('mobile', 'stepcur');

            var campaigns = $(this).data('campaigns');
            var cashbacks = $(this).data('cashbacks');
            if (campaigns) {
                getCampaignByService(campaigns, cashbacks, 'mobile');

                $left_id = "3-1";
                $right_id = "3-2";
                switch ($('input[type="radio"][name="step2"]:checked').val()) {
                    case '戸建住宅':
                        $("#step" + $right_id).removeClass("step-active");
                        $("#step" + $left_id).addClass("step-active");

                        break;

                    case '集合住宅':
                        $("#step" + $left_id).removeClass("step-active");
                        $("#step" + $right_id).addClass("step-active");
                        break;
                }
                getSelectedResults();

            }
        } else {
            $('.changed-plan-mobile').text('');
        }

        $('#step-res3').addClass('step-active');

        showSelectedResults();
    });

    $('input[type="radio"][name="stepcur-mobileoption-h"]').on('change', function () {
        // ご利用中のお客さま
        calcTotalByMonthChange();
        $('#step-res3').addClass('step-active');

        showSelectedResults();

        getSelectedResults();

        if ($('#cbMobile-cur2').is(':checked')) {
            setLeftResultsChange('mobileoption', 'stepcur');
        }
    });

    $('input[type="radio"][name="stepcur-tv-h"]').on('change', function () {
        // ご利用中のお客さま
        calcTotalByMonthChange();

        if ($('#cbTv-cur2').is(':checked')) {
            $('.not-changed-plan').hide();
            setLeftResultsChange('tv', 'stepcur');

            var campaigns = $(this).data('campaigns');
            var cashbacks = $(this).data('cashbacks');
            if (campaigns) {
                getCampaignByService(campaigns, cashbacks, 'tv');

                $left_id = "3-1";
                $right_id = "3-2";
                switch ($('input[type="radio"][name="step2"]:checked').val()) {
                    case '戸建住宅':
                        $("#step" + $right_id).removeClass("step-active");
                        $("#step" + $left_id).addClass("step-active");

                        break;

                    case '集合住宅':
                        $("#step" + $left_id).removeClass("step-active");
                        $("#step" + $right_id).addClass("step-active");
                        break;
                }
                getSelectedResults();

            }
        } else {
            $('.changed-plan-tv').text('');
        }
        $('#step-res3').addClass('step-active');

        showSelectedResults();
    });

    $('input[type="radio"][name="stepcur-phone-h"]').on('change', function () {
        // ご利用中のお客さま
        calcTotalByMonthChange();

        if ($('#cbPhone-cur2').is(':checked')) {
            $('.not-changed-plan').hide();
            setLeftResultsChange('phone', 'stepcur');

            var campaigns = $(this).data('campaigns');
            var cashbacks = $(this).data('cashbacks');
            if (campaigns) {
                getCampaignByService(campaigns, cashbacks, 'phone');

                $left_id = "3-1";
                $right_id = "3-2";
                switch ($('input[type="radio"][name="step2"]:checked').val()) {
                    case '戸建住宅':
                        $("#step" + $right_id).removeClass("step-active");
                        $("#step" + $left_id).addClass("step-active");

                        break;

                    case '集合住宅':
                        $("#step" + $left_id).removeClass("step-active");
                        $("#step" + $right_id).addClass("step-active");
                        break;
                }

                getSelectedResults();

            }
        } else {
            $('.changed-plan-phone').text('');
        }
        $('#step-res3').addClass('step-active');

        showSelectedResults();
    });

    // 集合住宅
    $('input[type="radio"][name="stepcur-net-m"]').on('change', function () {
        // ご利用中のお客さま
        calcTotalByMonthChange();

        if ($('#cbNet-cur2').is(':checked')) {
            $('.not-changed-plan').hide();
            setLeftResultsChange('net', 'stepcur');

            var campaigns = $(this).data('campaigns');
            var cashbacks = $(this).data('cashbacks');
            if (campaigns) {
                getCampaignByService(campaigns, cashbacks, 'net');

                $left_id = "3-1";
                $right_id = "3-2";
                switch ($('input[type="radio"][name="step2"]:checked').val()) {
                    case '戸建住宅':
                        $("#step" + $right_id).removeClass("step-active");
                        $("#step" + $left_id).addClass("step-active");

                        break;

                    case '集合住宅':
                        $("#step" + $left_id).removeClass("step-active");
                        $("#step" + $right_id).addClass("step-active");
                        break;
                }
                getSelectedResults();

            }
        } else {
            $('.changed-plan-net').text('');
        }
        $('#step-res3').addClass('step-active');

        showSelectedResults();
    });

    $('input[type="radio"][name="stepcur-mobile-m"]').on('change', function () {
        // ご利用中のお客さま
        calcTotalByMonthChange();

        if ($('#cbMobile-cur2').is(':checked')) {
            $('.not-changed-plan').hide();
            setLeftResultsChange('mobile', 'stepcur');

            var campaigns = $(this).data('campaigns');
            var cashbacks = $(this).data('cashbacks');
            if (campaigns) {
                getCampaignByService(campaigns, cashbacks, 'mobile');

                $left_id = "3-1";
                $right_id = "3-2";
                switch ($('input[type="radio"][name="step2"]:checked').val()) {
                    case '戸建住宅':
                        $("#step" + $right_id).removeClass("step-active");
                        $("#step" + $left_id).addClass("step-active");

                        break;

                    case '集合住宅':
                        $("#step" + $left_id).removeClass("step-active");
                        $("#step" + $right_id).addClass("step-active");
                        break;
                }
                getSelectedResults();

            }
        } else {
            $('.changed-plan-mobile').text('');
        }
        $('#step-res3').addClass('step-active');

        showSelectedResults();
    });

    $('input[type="radio"][name="stepcur-mobileoption-m"]').on('change', function () {
        // ご利用中のお客さま
        calcTotalByMonthChange();
        $('#step-res3').addClass('step-active');

        showSelectedResults();

        getSelectedResults();

        if ($('#cbMobile-cur2').is(':checked')) {
            setLeftResultsChange('mobileoption', 'stepcur');
        }
    });

    $('input[type="radio"][name="stepcur-tv-m"]').on('change', function () {
        // ご利用中のお客さま
        calcTotalByMonthChange();

        if ($('#cbTv-cur2').is(':checked')) {
            $('.not-changed-plan').hide();
            setLeftResultsChange('tv', 'stepcur');

            var campaigns = $(this).data('campaigns');
            var cashbacks = $(this).data('cashbacks');
            if (campaigns) {
                getCampaignByService(campaigns, cashbacks, 'tv');

                $left_id = "3-1";
                $right_id = "3-2";
                switch ($('input[type="radio"][name="step2"]:checked').val()) {
                    case '戸建住宅':
                        $("#step" + $right_id).removeClass("step-active");
                        $("#step" + $left_id).addClass("step-active");

                        break;

                    case '集合住宅':
                        $("#step" + $left_id).removeClass("step-active");
                        $("#step" + $right_id).addClass("step-active");
                        break;
                }
                getSelectedResults();

            }
        } else {
            $('.changed-plan-tv').text('');
        }
        $('#step-res3').addClass('step-active');

        showSelectedResults();
    });

    $('input[type="radio"][name="stepcur-phone-m"]').on('change', function () {
        // ご利用中のお客さま
        calcTotalByMonthChange();

        if ($('#cbPhone-cur2').is(':checked')) {
            $('.not-changed-plan').hide();
            setLeftResultsChange('phone', 'stepcur');

            var campaigns = $(this).data('campaigns');
            var cashbacks = $(this).data('cashbacks');
            if (campaigns) {
                getCampaignByService(campaigns, cashbacks, 'phone');

                $left_id = "3-1";
                $right_id = "3-2";
                switch ($('input[type="radio"][name="step2"]:checked').val()) {
                    case '戸建住宅':
                        $("#step" + $right_id).removeClass("step-active");
                        $("#step" + $left_id).addClass("step-active");

                        break;

                    case '集合住宅':
                        $("#step" + $left_id).removeClass("step-active");
                        $("#step" + $right_id).addClass("step-active");
                        break;
                }
                getSelectedResults();

            }
        } else {
            $('.changed-plan-phone').text('');
        }
        $('#step-res3').addClass('step-active');

        showSelectedResults();
    });


    // STEP07-CUR
    // 戸建住宅
    $('input[type="radio"][name="stepchange-net-h"]').on('change', function () {
        // ご利用中のお客さま
        initOptionNew();
        bringUnselectedOptions();
        calcTotalByMonthChange();

        if ($('#cbNet-cur2').is(':checked')) {
            $('.not-changed-plan').hide();
            var value = $('input[type="radio"][name="stepchange-net-h"]:checked').val();
            if (value == "なし") {
                value = "変更なし";
                $('.changed-plan-net').text(value);
            } else {
                setLeftResultsChange('net', 'stepchange');
            }
        } else {
            $('.changed-plan-net').text('');
        }

        $('#step-res3').addClass('step-active');

        showSelectedResults();
    });

    $('input[type="radio"][name="stepchange-mobile-h"]').on('change', function () {
        // ご利用中のお客さま
        initOptionNew();
        bringUnselectedOptions();
        calcTotalByMonthChange();

        if ($('#cbMobile-cur2').is(':checked')) {
            $('.not-changed-plan').hide();

            var value = $('input[type="radio"][name="stepchange-mobile-h"]:checked').val();
            if (value == "なし") {
                value = "変更なし";
                $('.changed-plan-mobile').text(value);
            } else {
                setLeftResultsChange('mobile', 'stepchange');
            }
        } else {
            $('.changed-plan-mobile').text('');
        }
        $('#step-res3').addClass('step-active');

        showSelectedResults();
    });

    $('input[type="radio"][name="stepchange-mobileoption-h"]').on('change', function () {
        // ご利用中のお客さま
        initOptionNew();
        bringUnselectedOptions();
        calcTotalByMonthChange();
        $('#step-res3').addClass('step-active');

        showSelectedResults();

        if ($('#cbMobile-cur2').is(':checked')) {
            setLeftResultsChange('mobileoption', 'stepchange');
        }
    });

    $('input[type="radio"][name="stepchange-tv-h"]').on('change', function () {
        // ご利用中のお客さま
        initOptionNew();
        bringUnselectedOptions();
        calcTotalByMonthChange();

        if ($('#cbTv-cur2').is(':checked')) {
            $('.not-changed-plan').hide();
            var value = $('input[type="radio"][name="stepchange-tv-h"]:checked').val();
            if (value == "なし") {
                value = "変更なし";
                $('.changed-plan-tv').text(value);
            } else {
                setLeftResultsChange('tv', 'stepchange');
            }
        } else {
            $('.changed-plan-tv').text('');
        }
        $('#step-res3').addClass('step-active');

        showSelectedResults();
    });

    $('input[type="radio"][name="stepchange-phone-h"]').on('change', function () {
        // ご利用中のお客さま
        initOptionNew();
        bringUnselectedOptions();
        calcTotalByMonthChange();

        if ($('#cbPhone-cur2').is(':checked')) {
            $('.not-changed-plan').hide();
            var value = $('input[type="radio"][name="stepchange-phone-h"]:checked').val();
            if (value == "なし") {
                value = "変更なし";
                $('.changed-plan-phone').text(value);
            } else {
                setLeftResultsChange('phone', 'stepchange');
            }

        } else {
            $('.changed-plan-phone').text('');
        }
        $('#step-res3').addClass('step-active');

        showSelectedResults();
    });

    // 集合住宅
    $('input[type="radio"][name="stepchange-net-m"]').on('change', function () {
        // ご利用中のお客さま
        initOptionNew();
        bringUnselectedOptions();
        calcTotalByMonthChange();

        if ($('#cbNet-cur2').is(':checked')) {
            $('.not-changed-plan').hide();
            var value = $('input[type="radio"][name="stepchange-net-m"]:checked').val();
            if (value == "なし") {
                value = "変更なし";
                $('.changed-plan-net').text(value);
            } else {
                setLeftResultsChange('net', 'stepchange');
            }

        } else {
            $('.changed-plan-net').text('');
        }

        $('#step-res3').addClass('step-active');

        showSelectedResults();
    });

    $('input[type="radio"][name="stepchange-mobile-m"]').on('change', function () {
        // ご利用中のお客さま
        initOptionNew();
        bringUnselectedOptions();
        calcTotalByMonthChange();

        if ($('#cbMobile-cur2').is(':checked')) {
            $('.not-changed-plan').hide();
            var value = $('input[type="radio"][name="stepchange-mobile-m"]:checked').val();
            if (value == "なし") {
                value = "変更なし";
                $('.changed-plan-mobile').text(value);
            } else {
                setLeftResultsChange('mobile', 'stepchange');
            }

        } else {
            $('.changed-plan-mobile').text('');
        }

        $('#step-res3').addClass('step-active');

        showSelectedResults();
    });

    $('input[type="radio"][name="stepchange-mobileoption-m"]').on('change', function () {
        // ご利用中のお客さま
        initOptionNew();
        bringUnselectedOptions();
        calcTotalByMonthChange();

        $('#step-res3').addClass('step-active');

        showSelectedResults();

        if ($('#cbMobile-cur2').is(':checked')) {
            setLeftResultsChange('mobileoption', 'stepchange');
        }
    });

    $('input[type="radio"][name="stepchange-tv-m"]').on('change', function () {
        // ご利用中のお客さま
        initOptionNew();
        bringUnselectedOptions();
        calcTotalByMonthChange();

        if ($('#cbTv-cur2').is(':checked')) {
            $('.not-changed-plan').hide();
            var value = $('input[type="radio"][name="stepchange-tv-m"]:checked').val();
            if (value == "なし") {
                value = "変更なし";
                $('.changed-plan-tv').text(value);
            } else {
                setLeftResultsChange('tv', 'stepchange');
            }

        } else {
            $('.changed-plan-tv').text('');
        }

        $('#step-res3').addClass('step-active');

        showSelectedResults();
    });

    $('input[type="radio"][name="stepchange-phone-m"]').on('change', function () {
        // ご利用中のお客さま
        initOptionNew();
        bringUnselectedOptions();
        calcTotalByMonthChange();

        if ($('#cbPhone-cur2').is(':checked')) {
            $('.not-changed-plan').hide();
            var value = $('input[type="radio"][name="stepchange-phone-m"]:checked').val();
            if (value == "なし") {
                value = "変更なし";
                $('.changed-plan-phone').text(value);
            } else {
                setLeftResultsChange('phone', 'stepchange');
            }

        } else {
            $('.changed-plan-phone').text('');
        }

        $('#step-res3').addClass('step-active');

        showSelectedResults();
    });

});

function hideQuestions(level) {
    var questions = [];

    switch (level) {
        case 0:
            clearLeftResults();
            questions.push(
                "step2",
                "step3-1", "step3-2",
                "step4",
                "step5",
                "step6", "step-net-h", "step-mobile-h", "step-mobileoption-h", "step-tv-h", "step-phone-h", "step-net-m", "step-mobile-m", "step-mobileoption-m", "step-tv-m", "step-phone-m",
                "step-res1", "step-res2");

            questions.push(
                "step3-cur",
                "step4-cur",
                "step5-cur",
                "step6-cur",
                "stepcur-net-h", "stepcur-mobile-h", "stepcur-mobileoption-h", "stepcur-tv-h", "stepcur-phone-h", "stepcur-net-m", "stepcur-mobile-m", "stepcur-mobileoption-m", "stepcur-tv-m", "stepcur-phone-m",
                "step7-cur",
                "stepchange-net-h", "stepchange-mobile-h", "stepchange-mobileoption-h", "stepchange-tv-h", "stepchange-phone-h", "stepchange-net-m", "stepchange-mobile-m", "stepchange-mobileoption-m", "stepchange-tv-m", "stepchange-phone-m",
                "step-res3");
            break;

        case 1:
            clearLeftResults();
            questions.push(
                "step3-1", "step3-2",
                "step4",
                "step5",
                "step6", "step-net-h", "step-mobile-h", "step-mobileoption-h", "step-tv-h", "step-phone-h", "step-net-m", "step-mobile-m", "step-mobileoption-m", "step-tv-m", "step-phone-m",
                "step-res1", "step-res2");

            questions.push(
                "step3-cur",
                "step4-cur",
                "step5-cur",
                "step6-cur",
                "stepcur-net-h", "stepcur-mobile-h", "stepcur-mobileoption-h", "stepcur-tv-h", "stepcur-phone-h", "stepcur-net-m", "stepcur-mobile-m", "stepcur-mobileoption-m", "stepcur-tv-m", "stepcur-phone-m",
                "step7-cur",
                "stepchange-net-h", "stepchange-mobile-h", "stepchange-mobileoption-h", "stepchange-tv-h", "stepchange-phone-h", "stepchange-net-m", "stepchange-mobile-m", "stepchange-mobileoption-m", "stepchange-tv-m", "stepchange-phone-m",
                "step-res3");
            break;

        case 2:
            clearLeftResults();
            questions.push(
                "step4",
                "step5",
                "step6",
                "step-net-h", "step-mobile-h", "step-mobileoption-h", "step-tv-h", "step-phone-h", "step-net-m", "step-mobile-m", "step-mobileoption-m", "step-tv-m", "step-phone-m",
                "step-res1", "step-res2");

            questions.push(
                "step4-cur",
                "step5-cur",
                "step6-cur",
                "stepcur-net-h", "stepcur-mobile-h", "stepcur-mobileoption-h", "stepcur-tv-h", "stepcur-phone-h", "stepcur-net-m", "stepcur-mobile-m", "stepcur-mobileoption-m", "stepcur-tv-m", "stepcur-phone-m",
                "step7-cur",
                "stepchange-net-h", "stepchange-mobile-h", "stepchange-mobileoption-h", "stepchange-tv-h", "stepchange-phone-h", "stepchange-net-m", "stepchange-mobile-m", "stepchange-mobileoption-m", "stepchange-tv-m", "stepchange-phone-m",
                "step-res3");

            break;

        case 3:
            clearLeftResults();
            questions.push("step5", "step3-1", "step3-2");

            questions.push(
                "step6-cur",
                "stepcur-net-h", "stepcur-mobile-h", "stepcur-mobileoption-h", "stepcur-tv-h", "stepcur-phone-h", "stepcur-net-m", "stepcur-mobile-m", "stepcur-mobileoption-m", "stepcur-tv-m", "stepcur-phone-m",
                "step7-cur",
                "stepchange-net-h", "stepchange-mobile-h", "stepchange-mobileoption-h", "stepchange-tv-h", "stepchange-phone-h", "stepchange-net-m", "stepchange-mobile-m", "stepchange-mobileoption-m", "stepchange-tv-m", "stepchange-phone-m",
                "step-res3");
            break;

        case 4:
            questions.push("step6", "step5-cur", "step-net-h", "step-mobile-h", "step-mobileoption-h", "step-tv-h", "step-phone-h", "step-net-m", "step-mobile-m", "step-mobileoption-m", "step-tv-m", "step-phone-m",
                "step-res1", "step-res2");

            break;
    }

    $.each(questions, function (index, value) {
        $("#" + value).removeClass("step-active");
        $('input[type="radio"][name="' + value + '"]').prop('checked', false);

    });
}

// remove selection
function initService(name) {
    $('input[type="checkbox"][name="' + name + '"]').prop('checked', false);
}

// remove selection
function initCampaign() {
    $('input[type="checkbox"][name="step3-1"]').prop('checked', false);
    $('input[type="checkbox"][name="step3-2"]').prop('checked', false);
}

// show/hide selected services options
function showhideServices(service, cb) {
    let step2_val = $('input[type="radio"][name="step2"]:checked').val();
    switch (step2_val) {
        case "戸建住宅":
            // service select
            $('.service-' + service + '-m').removeClass("step-active");

            if ($('#' + cb).is(':checked')) {
                $('.service-' + service + '-h').addClass("step-active");
            } else {
                $('.service-' + service + '-h').removeClass("step-active");
                $('input[type="radio"][name="step-' + service + '-h"]').prop('checked', false);

                initOptionNew();
            }
            break;

        case "集合住宅":

            // NET
            // service select
            $('.service-' + service + '-h').removeClass("step-active");

            if ($('#' + cb).is(':checked')) {
                $('.service-' + service + '-m').addClass("step-active");
            } else {
                $('.service-' + service + '-m').removeClass("step-active");
                $('input[type="radio"][name="step-' + service + '-m"]').prop('checked', false);

                initOptionNew();
            }
            // service change
            $('.servicenew-' + service + '-h').removeClass("step-active");
            if ($('#' + cb + '-cur2').is(':checked')) {
                $('.servicenew-' + service + '-m').addClass("step-active");
            } else {
                $('.servicenew-' + service + '-m').removeClass("step-active");
                $('input[type="radio"][name="stepcur-' + service + '-m"]').prop('checked', false);

                initOptionNew();
            }
            break;
    }
}

// new/change
function showhideServicesChange(service, cb) {
    let step2_val = $('input[type="radio"][name="step2"]:checked').val();
    switch (step2_val) {
        case "戸建住宅":

            // service current
            $('.service-' + service + '-m').removeClass("step-active");
            $('.service-' + service + '-h').removeClass("step-active");

            if ($('#' + cb + '-cur').is(':checked')) {
                $('.service-' + service + '-h').addClass("step-active");
            } else {

                $('.service-' + service + '-h').removeClass("step-active");

                $('input[type="radio"][name="step-' + service + '-h"]').prop('checked', false);
                $('input[type="radio"][name="stepcur-' + service + '-h"]').prop('checked', false);
                $('input[type="radio"][name="stepchange-' + service + '-h"]').prop('checked', false);



            }

            // service new
            $('.servicenew-' + service + '-m').removeClass("step-active");
            if ($('#' + cb + '-cur2').is(':checked')) {
                if ($('#' + cb + '-cur').is(':checked')) {
                    $('.servicenew-' + service + '-h').removeClass("step-active");
                } else {
                    $('.servicenew-' + service + '-h').addClass("step-active");
                }
            } else {
                $('.servicenew-' + service + '-h').removeClass("step-active");
                $('input[type="radio"][name="stepcur-' + service + '-h"]').prop('checked', false);
                $('input[type="radio"][name="stepchange-' + service + '-h"]').prop('checked', false);
            }
            // service change
            $('.servicechange-' + service + '-m').removeClass("step-active");
            if ($('#' + cb + '-cur2').is(':checked')) {
                if ($('#' + cb + '-cur').is(':checked')) {
                    $('.servicechange-' + service + '-h').addClass("step-active");
                } else {
                    $('.servicechange-' + service + '-h').removeClass("step-active");
                }
            } else {
                $('.servicechange-' + service + '-h').removeClass("step-active");
                $('input[type="radio"][name="stepchange-' + service + '-h"]').prop('checked', false);
            }

            break;

        case "集合住宅":

            // service current
            $('.service-' + service + '-h').removeClass("step-active");
            if ($('#' + cb + '-cur').is(':checked')) {
                $('.service-' + service + '-m').addClass("step-active");
            } else {
                $('.service-' + service + '-m').removeClass("step-active");
                $('input[type="radio"][name="step-' + service + '-h"]').prop('checked', false);
                $('input[type="radio"][name="stepcur-' + service + '-m"]').prop('checked', false);
                $('input[type="radio"][name="stepchange-' + service + '-m"]').prop('checked', false);
            }

            // service new
            $('.servicenew-' + service + '-h').removeClass("step-active");
            if ($('#' + cb + '-cur2').is(':checked')) {
                if ($('#' + cb + '-cur').is(':checked')) {
                    $('.servicenew-' + service + '-m').removeClass("step-active");
                } else {
                    $('.servicenew-' + service + '-m').addClass("step-active");
                }
            } else {
                $('.servicenew-' + service + '-m').removeClass("step-active");
                $('input[type="radio"][name="stepcur-' + service + '-m"]').prop('checked', false);
                $('input[type="radio"][name="stepchange-' + service + '-m"]').prop('checked', false);

            }
            // service change
            $('.servicechange-' + service + '-h').removeClass("step-active");
            if ($('#' + cb + '-cur2').is(':checked')) {
                if ($('#' + cb + '-cur').is(':checked')) {
                    $('.servicechange-' + service + '-m').addClass("step-active");
                } else {
                    $('.servicechange-' + service + '-m').removeClass("step-active");
                }
            } else {
                $('.servicechange-' + service + '-m').removeClass("step-active");
                $('input[type="radio"][name="stepchange-' + service + '-m"]').prop('checked', false);
            }

            break;
    }
}

function clearServicesSelection() {
    $('input[type="radio"][name="step-net-h"]').prop('checked', false);
    $('input[type="radio"][name="step-mobile-h"]').prop('checked', false);
    $('input[type="radio"][name="step-tv-h"]').prop('checked', false);
    $('input[type="radio"][name="step-phone-h"]').prop('checked', false);

    $('input[type="radio"][name="step-net-m"]').prop('checked', false);
    $('input[type="radio"][name="step-mobile-m"]').prop('checked', false);
    $('input[type="radio"][name="step-tv-m"]').prop('checked', false);
    $('input[type="radio"][name="step-phone-m"]').prop('checked', false);
}

function initCurrentPrice() {
    $('#currentprice').val('');
}

function bringUnselectedOptions() {
    initOptionChange();
    let step2_val = $('input[type="radio"][name="step2"]:checked').val();
    switch (step2_val) {
        case "戸建住宅":

            if ($('#cbNet-cur').is(':checked') && $('input[type="radio"][name="step-net-h"]:checked').length > 0) {
                id = $('input[type="radio"][name="step-net-h"]:checked').data("id");
                $('#net-option-h-' + id).hide();

                // set current
                $('#currentplan__net-h').text($('.currentplan-net-h-' + id).val());
                $('#currentplan__net-h-price').text($('.net-price-h-' + id).val());
                price = txtToNumber($('.net-price-h-' + id).val());
                var taxprice = price * 0.1 + price;
                $('#currentplan__net-h-taxprice').text(numberToTxt(taxprice));
            }

            if ($('#cbMobile-cur').is(':checked') && $('input[type="radio"][name="step-mobile-h"]:checked').length > 0) {

                id = $('input[type="radio"][name="step-mobile-h"]:checked').data("id");
                $('#mobile-option-h-' + id).hide();

                idOption = $('input[type="radio"][name="step-mobileoption-h"]:checked').data("id");
                $('#mobileoption-option-h-' + idOption).hide();

                // set current
                $('#currentplan__mobile-h').text($('.currentplan-mobile-h-' + id).val());
                $('#currentplan__mobile-h-price').text($('.mobile-price-h-' + id).val());
                price = txtToNumber($('.mobile-price-h-' + id).val());
                var taxprice = price * 0.1 + price;
                $('#currentplan__mobile-h-taxprice').text(numberToTxt(taxprice));

            }

            if ($('#cbTv-cur').is(':checked') && $('input[type="radio"][name="step-tv-h"]:checked').length > 0) {
                id = $('input[type="radio"][name="step-tv-h"]:checked').data("id");
                $('#tv-option-h-' + id).hide();

                // set current
                $('#currentplan__tv-h').text($('.currentplan-tv-h-' + id).val());
                $('#currentplan__tv-h-price').text($('.tv-pricecur-h-' + id).val());
                price = txtToNumber($('.tv-pricecur-h-' + id).val());
                var taxprice = price * 0.1 + price;
                $('#currentplan__tv-h-taxprice').text(numberToTxt(taxprice));

                $('[data-tvstatus="false"]').hide();
            }

            if ($('#cbPhone-cur').is(':checked') && $('input[type="radio"][name="step-phone-h"]:checked').length > 0) {
                id = $('input[type="radio"][name="step-phone-h"]:checked').data("id");
                $('#phone-option-h-' + id).hide();

                // set current
                $('#currentplan__phone-h').text($('.currentplan-phone-h-' + id).val());
                $('#currentplan__phone-h-price').text($('.phone-price-h-' + id).val());
                price = txtToNumber($('.phone-price-h-' + id).val());
                var taxprice = price * 0.1 + price;
                $('#currentplan__phone-h-taxprice').text(numberToTxt(taxprice));
            }

            break;

        case "集合住宅":
            if ($('#cbNet-cur').is(':checked') && $('input[type="radio"][name="step-net-m"]:checked').length > 0) {
                id = $('input[type="radio"][name="step-net-m"]:checked').data("id");
                $('#net-option-m-' + id).hide();

                // set current
                $('#currentplan__net-m').text($('.currentplan-net-m-' + id).val());
                $('#currentplan__net-m-price').text($('.net-price-m-' + id).val());
                price = txtToNumber($('.net-price-m-' + id).val());
                var taxprice = price * 0.1 + price;
                $('#currentplan__net-m-taxprice').text(numberToTxt(taxprice));
            }

            if ($('#cbMobile-cur').is(':checked') && $('input[type="radio"][name="step-mobile-m"]:checked').length > 0) {
                id = $('input[type="radio"][name="step-mobile-m"]:checked').data("id");
                $('#mobile-option-m-' + id).hide();

                idOption = $('input[type="radio"][name="step-mobileoption-m"]:checked').data("id");
                $('#mobileoption-option-m-' + idOption).hide();

                // set current
                $('#currentplan__mobile-m').text($('.currentplan-mobile-m-' + id).val());
                $('#currentplan__mobile-m-price').text($('.mobile-price-m-' + id).val());
                price = txtToNumber($('.mobile-price-m-' + id).val());
                var taxprice = price * 0.1 + price;
                $('#currentplan__mobile-m-taxprice').text(numberToTxt(taxprice));

            }

            if ($('#cbTv-cur').is(':checked') && $('input[type="radio"][name="step-tv-m"]:checked').length > 0) {
                id = $('input[type="radio"][name="step-tv-m"]:checked').data("id");
                $('#tv-option-m-' + id).hide();

                // set current
                $('#currentplan__tv-m').text($('.currentplan-tv-m-' + id).val());
                $('#currentplan__tv-m-price').text($('.tv-pricecur-m-' + id).val());
                price = txtToNumber($('.tv-pricecur-m-' + id).val());
                var taxprice = price * 0.1 + price;
                $('#currentplan__tv-m-taxprice').text(numberToTxt(taxprice));

                $('[data-tvstatus="false"]').hide();

            }

            if ($('#cbPhone-cur').is(':checked') && $('input[type="radio"][name="step-phone-m"]:checked').length > 0) {
                id = $('input[type="radio"][name="step-phone-m"]:checked').data("id");
                $('#phone-option-m-' + id).hide();

                // set current
                $('#currentplan__phone-m').text($('.currentplan-phone-m-' + id).val());
                $('#currentplan__phone-m-price').text($('.phone-price-m-' + id).val());
                price = txtToNumber($('.phone-price-m-' + id).val());
                var taxprice = price * 0.1 + price;
                $('#currentplan__phone-m-taxprice').text(numberToTxt(taxprice));
            }

            break;
    }

}

function initOptionNew() {
    $('.option-new').css("display", "flex");
}

function initOptionChange() {
    $('.option-change').css("display", "flex");
}

function verifySelectedServices() {
    const checkboxCurrent = $('input[type="checkbox"][name="step3-cur"]:checked');
    const checkBoxChange = $('input[type="checkbox"][name="step5-cur"]:checked');

    const currentSelected = checkboxCurrent.map(function () {
        return $(this).val();
    }).get();

    const changeSelected = checkBoxChange.map(function () {
        return $(this).val();
    }).get();


    const same = changeSelected.some(function (valor) {
        return currentSelected.includes(valor);
    });

    if (same) {
        $("#step7-cur").addClass("step-active");
        $(".table-change").addClass("step-active");
    } else {
        $("#step6-cur").addClass("step-active");
        $(".table-new").addClass("step-active");

        $("#step7-cur").removeClass("step-active");
        $(".table-change").removeClass("step-active");
    }

    const equals = changeSelected.filter(function (valor) {
        return currentSelected.includes(valor);
    });

    const adicional = changeSelected.filter(function (valor) {
        return !equals.includes(valor);
    });

    if (adicional.length > 0) {
        $("#step6-cur").addClass("step-active");
        $(".table-new").addClass("step-active");
    } else {
        $("#step6-cur").removeClass("step-active");
        $(".table-new").removeClass("step-active");

    }
}

function hasCampaign(service, cbService) {
    let step2_val = $('input[type="radio"][name="step2"]:checked').val();
    switch (step2_val) {
        case "戸建住宅":
            if ($('#' + cbService).is(':checked')) {
                var campaigns = false;
                campaigns = $('input[type="radio"][name="step-' + service + '-h"]').data('campaigns')
                return campaigns;
            }


            break;

        case "集合住宅":
            if ($('#' + cbService).is(':checked')) {
                var campaigns = false;
                campaigns = $('input[type="radio"][name="step-' + service + '-m"]').data('campaigns')
                return campaigns;
            }
            break;
    }
}

// function setCurrentServices() {
//     let step2_val = $('input[type="radio"][name="step2"]:checked').val();
//     switch (step2_val) {
//         case "戸建住宅":

//             if ($('#cbNet-cur').is(':checked')) {
//                 id = $('input[type="radio"][name="step-net-h"]:checked').data("id");

//                 // set current
//                 $('#currentplan__net-h').text($('.currentplan-net-h-' + id).val());
//                 $('#currentplan__net-h-price').text($('.net-price-h-' + id).val());
//                 price = txtToNumber($('.net-price-h-' + id).val());
//                 var taxprice = price * 0.1 + price;
//                 $('#currentplan__net-h-taxprice').text(numberToTxt(taxprice));
//             }

//             if ($('#cbMobile-cur').is(':checked')) {
//                 id = $('input[type="radio"][name="step-mobile-h"]:checked').data("id");

//                 // set current
//                 if ($('input[type="radio"][name="stepchange-mobile-h"]').is(':checked')) {
//                     $('#currentplan__mobile-h').text($('.currentplan-mobile-h-' + id).val());
//                     $('#currentplan__mobile-h-price').text($('.mobile-price-h-' + id).val());
//                     price = txtToNumber($('.mobile-price-h-' + id).val());
//                     var taxprice = price * 0.1 + price;
//                     $('#currentplan__mobile-h-taxprice').text(numberToTxt(taxprice));
//                 }

//             }

//             if ($('#cbTv-cur').is(':checked')) {
//                 id = $('input[type="radio"][name="step-tv-h"]:checked').data("id");

//                 // set current
//                 if ($('input[type="radio"][name="stepchange-tv-h"]').is(':checked')) {
//                     $('#currentplan__tv-h').text($('.currentplan-tv-h-' + id).val());
//                     $('#currentplan__tv-h-price').text($('.tv-price-h-' + id).val());
//                     price = txtToNumber($('.tv-price-h-' + id).val());
//                     var taxprice = price * 0.1 + price;
//                     $('#currentplan__tv-h-taxprice').text(numberToTxt(taxprice));
//                 }
//             }

//             if ($('#cbPhone-cur').is(':checked')) {
//                 id = $('input[type="radio"][name="step-phone-h"]:checked').data("id");

//                 // set current
//                 if ($('input[type="radio"][name="stepchange-phone-h"]').is(':checked')) {
//                     $('#currentplan__phone-h').text($('.currentplan-phone-h-' + id).val());
//                     $('#currentplan__phone-h-price').text($('.phone-price-h-' + id).val());
//                     price = txtToNumber($('.phone-price-h-' + id).val());
//                     var taxprice = price * 0.1 + price;
//                     $('#currentplan__phone-h-taxprice').text(numberToTxt(taxprice));
//                 }
//             }


//             break;
//         case "集合住宅": break;
//     }
// }

function initCurrentServices() {
    $('#service-net-h').removeClass("step-active");
    $('.service-mobile-h').removeClass("step-active");
    $('.service-tv-h').removeClass("step-active");
    $('.service-phone-h').removeClass("step-active");
    $('.service-net-m').removeClass("step-active");
    $('.service-mobile-m').removeClass("step-active");
    $('.service-tv-m').removeClass("step-active");
    $('.service-phone-m').removeClass("step-active");
}

function showCampaignByServices() {
    let step2_val = $('input[type="radio"][name="step2"]:checked').val();
    let step1_val = $('input[type="radio"][name="step1"]:checked').val();

    switch (step2_val) {
        case "戸建住宅":
            switch (step1_val) {
                case "ご検討のお客さま":
                    // ご検討のお客さま
                    if ($('#cbNet').is(':checked')) {
                        $('#step3-1-net').addClass('camp-active');
                    } else {
                        $('#step3-1-net').removeClass('camp-active');
                    }

                    if ($('#cbMobile').is(':checked')) {
                        $('#step3-1-mobile').addClass('camp-active');
                    } else {
                        $('#step3-1-mobile').removeClass('camp-active');
                    }

                    if ($('#cbTv').is(':checked')) {
                        $('#step3-1-tv').addClass('camp-active');
                    } else {
                        $('#step3-1-tv').removeClass('camp-active');
                    }

                    if ($('#cbPhone').is(':checked')) {
                        $('#step3-1-phone').addClass('camp-active');
                    } else {
                        $('#step3-1-phone').removeClass('camp-active');
                    }
                    break;

                case "ご利用中のお客さま":
                    // ご利用中のお客さま
                    if ($('#cbNet-cur2').is(':checked') && !$('#cbNet-cur').is(':checked')) {
                        $('#step3-1-net').addClass('camp-active');
                    } else {
                        $('#step3-1-net').removeClass('camp-active');
                    }

                    if ($('#cbMobile-cur2').is(':checked') && !$('#cbMobile-cur').is(':checked')) {
                        $('#step3-1-mobile').addClass('camp-active');
                    } else {
                        $('#step3-1-mobile').removeClass('camp-active');
                    }

                    if ($('#cbTv-cur2').is(':checked') && !$('#cbTv-cur').is(':checked')) {
                        $('#step3-1-tv').addClass('camp-active');
                    } else {
                        $('#step3-1-tv').removeClass('camp-active');
                    }

                    if ($('#cbPhone-cur2').is(':checked') && !$('#cbPhone-cur').is(':checked')) {
                        $('#step3-1-phone').addClass('camp-active');
                    } else {
                        $('#step3-1-phone').removeClass('camp-active');
                    }
                    break;

            }
            break;

        case "集合住宅":
            switch (step1_val) {
                case "ご検討のお客さま":
                    // ご検討のお客さま
                    if ($('#cbNet').is(':checked')) {
                        $('#step3-2-net').addClass('camp-active');
                    } else {
                        $('#step3-2-net').removeClass('camp-active');
                    }

                    if ($('#cbMobile').is(':checked')) {
                        $('#step3-2-mobile').addClass('camp-active');
                    } else {
                        $('#step3-2-mobile').removeClass('camp-active');
                    }

                    if ($('#cbTv').is(':checked')) {
                        $('#step3-2-tv').addClass('camp-active');
                    } else {
                        $('#step3-2-tv').removeClass('camp-active');
                    }

                    if ($('#cbPhone').is(':checked')) {
                        $('#step3-2-phone').addClass('camp-active');
                    } else {
                        $('#step3-2-phone').removeClass('camp-active');
                    }
                    break;

                case "ご利用中のお客さま":
                    // ご利用中のお客さま
                    if ($('#cbNet-cur2').is(':checked')) {
                        $('#step3-2-net').addClass('camp-active');
                    } else {
                        $('#step3-2-net').removeClass('camp-active');
                    }

                    if ($('#cbMobile-cur2').is(':checked')) {
                        $('#step3-2-mobile').addClass('camp-active');
                    } else {
                        $('#step3-2-mobile').removeClass('camp-active');
                    }

                    if ($('#cbTv-cur2').is(':checked')) {
                        $('#step3-2-tv').addClass('camp-active');
                    } else {
                        $('#step3-2-tv').removeClass('camp-active');
                    }

                    if ($('#cbPhone-cur2').is(':checked')) {
                        $('#step3-2-phone').addClass('camp-active');
                    } else {
                        $('#step3-2-phone').removeClass('camp-active');
                    }
                    break;
            }
            break;
    }
}

function initCampaignByServices() {
    // campaign
    $('input[type="checkbox"][name="step3-1-net"]').prop('checked', false);
    $('input[type="checkbox"][name="step3-1-mobile"]').prop('checked', false);
    $('input[type="checkbox"][name="step3-1-tv"]').prop('checked', false);
    $('input[type="checkbox"][name="step3-1-phone"]').prop('checked', false);

    $('input[type="checkbox"][name="step3-2-net"]').prop('checked', false);
    $('input[type="checkbox"][name="step3-2-mobile"]').prop('checked', false);
    $('input[type="checkbox"][name="step3-2-tv"]').prop('checked', false);
    $('input[type="checkbox"][name="step3-2-phone"]').prop('checked', false);

    // others
    $('input[type="checkbox"][name="step3-1-cb-net"]').prop('checked', false);
    $('input[type="checkbox"][name="step3-1-cb-mobile"]').prop('checked', false);
    $('input[type="checkbox"][name="step3-1-cb-tv"]').prop('checked', false);
    $('input[type="checkbox"][name="step3-1-cb-phone"]').prop('checked', false);

    $('input[type="checkbox"][name="step3-2-cb-net"]').prop('checked', false);
    $('input[type="checkbox"][name="step3-2-cb-mobile"]').prop('checked', false);
    $('input[type="checkbox"][name="step3-2-cb-tv"]').prop('checked', false);
    $('input[type="checkbox"][name="step3-2-cb-phone"]').prop('checked', false);

    getSelectedResults();
}

function getCampaignByService(campaigns, cashbacks, service) {

    var servicejp = "";
    if (service === "net") {
        servicejp = "ネット";
    } else if (service === "mobile") {
        servicejp = "モバイル";
    } else if (service === "tv") {
        servicejp = "テレビ";
    } else if (service === "phone") {
        servicejp = "固定電話";
    }

    let step2_val = $('input[type="radio"][name="step2"]:checked').val();
    if (step2_val === "戸建住宅") {
        $('#step3-1-' + service).empty();

        if (campaigns && campaigns.length > 0) {
            $('#step3-1-' + service).append(`<p class="aic-simulator__service-name icon-${service}">${servicejp}</p>`);
            campaigns.forEach(function (campaign, index) {
                $('#step3-1-' + service).append(`
                    <label class="aic-simulator__option option-type-2 --row">
                        <input type="checkbox" name="step3-1-${service}" class="hidden-radio" data-id="${index}" value="${campaign['aic-campaign-name']}" checked>
                        <div class="option__checkmark"></div>
                        <div class="option-details">
                            <p class="option__name">${campaign['aic-campaign-name']}</p>
                            <p class="option__description">${campaign['aic-campaign-house']}</p>
                            <input type="hidden" name="campaign-discount-h" class="campaign-discount-h-${index} campaign-${service}-discount-h-${index}" value="${campaign['aic-campaign-house-discount']}">
                            <input type="hidden" name="campaign-months-h" class="campaign-months-h-${index} campaign-${service}-months-h-${index}" value="${campaign['aic-campaign-house-months']}">
                        </div>
                    </label>
                `);
            });
        }

        if (cashbacks && cashbacks.length > 0) {
            cashbacks.forEach(function (cashback, index) {
                $('#step3-1-' + service).append(`
                    <label class="aic-simulator__option option-type-2 --row">
                        <input type="checkbox" name="step3-1-cb-${service}" class="hidden-radio" data-id="${index}" data-cbname="${cashback['aic-cashback-name']}" value="${cashback['aic-cashback-name']}" checked>
                        <div class="option__checkmark"></div>
                        <div class="option-details">
                            <p class="option__name">${cashback['aic-cashback-name']}</p>
                            <p class="option__description">${cashback['aic-cashback-house']}</p>
                            <input type="hidden" name="cashback-value-h" class="cashback-${service}-value-h-${index}" value="${cashback['aic-cashback-house-value']}">
                        </div>
                    </label>
                `);
            });
        }

    } else if (step2_val === "集合住宅") {

        $('#step3-2-' + service).empty();

        if (campaigns && campaigns.length > 0) {
            $('#step3-2-' + service).append(`<p class="aic-simulator__service-name icon-${service}">${servicejp}</p>`);
            campaigns.forEach(function (campaign, index) {
                $('#step3-2-' + service).append(`
                    <label class="aic-simulator__option option-type-2 --row">
                        <input type="checkbox" name="step3-2-${service}" class="hidden-radio" data-id="${index}" value="${campaign['aic-campaign-name']}" checked>
                        <div class="option__checkmark"></div>
                        <div class="option-details">
                            <p class="option__name">${campaign['aic-campaign-name']}</p>
                            <p class="option__description">${campaign['aic-campaign-mansion']}</p>
                            <input type="hidden" name="campaign-discount-m" class="campaign-discount-m-${index} campaign-${service}-discount-m-${index}" value="${campaign['aic-campaign-mansion-discount']}">
                            <input type="hidden" name="campaign-months-m" class="campaign-months-m-${index} campaign-${service}-months-m-${index}" value="${campaign['aic-campaign-mansion-months']}">
                        </div>
                    </label>
                `);
            });
        }

        if (cashbacks && cashbacks.length > 0) {
            cashbacks.forEach(function (cashback, index) {
                $('#step3-2-' + service).append(`
                    <label class="aic-simulator__option option-type-2 --row">
                        <input type="checkbox" name="step3-2-cb-${service}" class="hidden-radio" data-id="${index}" data-cbname="${cashback['aic-cashback-name']}" value="${cashback['aic-cashback-name']}" checked>
                        <div class="option__checkmark"></div>
                        <div class="option-details">
                            <p class="option__name">${cashback['aic-cashback-name']}</p>
                            <p class="option__description">${cashback['aic-cashback-mansion']}</p>
                            <input type="hidden" name="cashback-value-m" class="cashback-${service}-value-m-${index}" value="${cashback['aic-cashback-mansion-value']}">
                        </div>
                    </label>
                `);
            });
        }
    }
}

function setStepTitle() {
    let step1_val = $('input[type="radio"][name="step1"]:checked').val();
    if (step1_val !== "ご検討のお客さま") {
        if ($('#step6-cur').hasClass('step-active')) {
            $('.step-change-title').text("STEP 07");

            if ($('#step7-cur').hasClass('step-active')) {
                $('.step-camp-title').text("STEP 08");
            } else {
                $('.step-camp-title').text("STEP 07");
            }
        } else {
            $('.step-change-title').text("STEP 06");
            $('.step-camp-title').text("STEP 07");
        }
    }

}

function setMobileOptionDefault(step) {
    document.querySelector('input[name="' + step + '-mobileoption-h"][value="なし"]').checked = true;
    document.querySelector('input[name="' + step + '-mobileoption-m"][value="なし"]').checked = true;

}

// ------------------------------
// 左のシミュレーター結果
// ------------------------------
$(document).ready(function () {
    // get selected campaigns
    // $('input[type="checkbox"][name="step3-1"]').on('change', function () {
    //     var selectedCampaigns = $('input[type="checkbox"][name="step3-1"]:checked').map(function () {
    //         return $(this).val();
    //     }).get().join('\n\n');

    //     $('.selected-campaign').text(selectedCampaigns);
    // });

    // $('input[type="checkbox"][name="step3-2"]').on('change', function () {
    //     var selectedCampaigns = $('input[type="checkbox"][name="step3-2"]:checked').map(function () {
    //         return $(this).val();
    //     }).get().join('\n\n');

    //     $('.selected-campaign').text(selectedCampaigns);
    // });

    var updateSelectedCampaignsH = function () {

        var camp_net = $('input[type="checkbox"][name="step3-1-net"]:checked').map(function () {
            return $(this).val();
        }).get();

        var camp_mobile = $('input[type="checkbox"][name="step3-1-mobile"]:checked').map(function () {
            return $(this).val();
        }).get();

        var camp_tv = $('input[type="checkbox"][name="step3-1-tv"]:checked').map(function () {
            return $(this).val();
        }).get();

        var camp_phone = $('input[type="checkbox"][name="step3-1-phone"]:checked').map(function () {
            return $(this).val();
        }).get();

        var cashback_net = $('input[type="checkbox"][name="step3-1-cb-net"]:checked').map(function () {
            return $(this).val();
        }).get();

        var cashback_mobile = $('input[type="checkbox"][name="step3-1-cb-mobile"]:checked').map(function () {
            return $(this).val();
        }).get();

        var cashback_tv = $('input[type="checkbox"][name="step3-1-cb-tv"]:checked').map(function () {
            return $(this).val();
        }).get();

        var cashback_phone = $('input[type="checkbox"][name="step3-1-cb-phone"]:checked').map(function () {
            return $(this).val();
        }).get();

        var allSelected = [].concat(camp_net, camp_mobile, camp_tv, camp_phone, cashback_net, cashback_mobile, cashback_tv, cashback_phone).join('\n\n');

        $('.selected-campaign').text(allSelected);
    };
    $(document).on('change',
        'input[type="checkbox"][name="step3-1-net"], input[type="checkbox"][name="step3-1-mobile"], input[type="checkbox"][name="step3-1-tv"], input[type="checkbox"][name="step3-1-phone"], input[type="checkbox"][name="step3-1-cb-net"], input[type="checkbox"][name="step3-1-cb-mobile"], input[type="checkbox"][name="step3-1-cb-tv"], input[type="checkbox"][name="step3-1-cb-phone"],' +
        'input[type="radio"][name="step-net-h"],input[type="radio"][name="step-mobile-h"],input[type="radio"][name="step-tv-h"],input[type="radio"][name="step-phone-h"]',
        updateSelectedCampaignsH);


    var updateSelectedCampaignsM = function () {

        var camp_net = $('input[type="checkbox"][name="step3-2-net"]:checked').map(function () {
            return $(this).val();
        }).get();

        var camp_mobile = $('input[type="checkbox"][name="step3-2-mobile"]:checked').map(function () {
            return $(this).val();
        }).get();

        var camp_tv = $('input[type="checkbox"][name="step3-2-tv"]:checked').map(function () {
            return $(this).val();
        }).get();

        var camp_phone = $('input[type="checkbox"][name="step3-2-phone"]:checked').map(function () {
            return $(this).val();
        }).get();

        var cashback_net = $('input[type="checkbox"][name="step3-2-cb-net"]:checked').map(function () {
            return $(this).val();
        }).get();

        var cashback_mobile = $('input[type="checkbox"][name="step3-2-cb-mobile"]:checked').map(function () {
            return $(this).val();
        }).get();

        var cashback_tv = $('input[type="checkbox"][name="step3-2-cb-tv"]:checked').map(function () {
            return $(this).val();
        }).get();

        var cashback_phone = $('input[type="checkbox"][name="step3-2-cb-phone"]:checked').map(function () {
            return $(this).val();
        }).get();

        var allSelected = [].concat(camp_net, camp_mobile, camp_tv, camp_phone, cashback_net, cashback_mobile, cashback_tv, cashback_phone).join('\n\n');

        $('.selected-campaign').text(allSelected);
    };
    $(document).on('change',
        'input[type="checkbox"][name="step3-2-net"], input[type="checkbox"][name="step3-2-mobile"], input[type="checkbox"][name="step3-2-tv"], input[type="checkbox"][name="step3-2-phone"], input[type="checkbox"][name="step3-2-cb-net"], input[type="checkbox"][name="step3-2-cb-mobile"], input[type="checkbox"][name="step3-2-cb-tv"], input[type="checkbox"][name="step3-2-cb-phone"],' +
        'input[type="radio"][name="stepcur-net-h"],input[type="radio"][name="stepcur-mobile-h"],input[type="radio"][name="stepcur-tv-h"],input[type="radio"][name="stepcur-phone-h"]',
        updateSelectedCampaignsM);


});

function setLeftCampaign() {
    var step2 = $('input[type="radio"][name="step2"]:checked').val();
    if (step2 == "戸建住宅") {
        var camp_net = $('input[type="checkbox"][name="step3-1-net"]:checked').map(function () {
            return $(this).val();
        }).get();

        var camp_mobile = $('input[type="checkbox"][name="step3-1-mobile"]:checked').map(function () {
            return $(this).val();
        }).get();

        var camp_tv = $('input[type="checkbox"][name="step3-1-tv"]:checked').map(function () {
            return $(this).val();
        }).get();

        var camp_phone = $('input[type="checkbox"][name="step3-1-phone"]:checked').map(function () {
            return $(this).val();
        }).get();

        var cashback_net = $('input[type="checkbox"][name="step3-1-cb-net"]:checked').map(function () {
            return $(this).val();
        }).get();

        var cashback_mobile = $('input[type="checkbox"][name="step3-1-cb-mobile"]:checked').map(function () {
            return $(this).val();
        }).get();

        var cashback_tv = $('input[type="checkbox"][name="step3-1-cb-tv"]:checked').map(function () {
            return $(this).val();
        }).get();

        var cashback_phone = $('input[type="checkbox"][name="step3-1-cb-phone"]:checked').map(function () {
            return $(this).val();
        }).get();

        var allSelected = [].concat(camp_net, camp_mobile, camp_tv, camp_phone, cashback_net, cashback_mobile, cashback_tv, cashback_phone).join('\n\n');

    } else if (step2 == "集合住宅") {

        var camp_net = $('input[type="checkbox"][name="step3-2-net"]:checked').map(function () {
            return $(this).val();
        }).get();

        var camp_mobile = $('input[type="checkbox"][name="step3-2-mobile"]:checked').map(function () {
            return $(this).val();
        }).get();

        var camp_tv = $('input[type="checkbox"][name="step3-2-tv"]:checked').map(function () {
            return $(this).val();
        }).get();

        var camp_phone = $('input[type="checkbox"][name="step3-2-phone"]:checked').map(function () {
            return $(this).val();
        }).get();

        var cashback_net = $('input[type="checkbox"][name="step3-2-cb-net"]:checked').map(function () {
            return $(this).val();
        }).get();

        var cashback_mobile = $('input[type="checkbox"][name="step3-2-cb-mobile"]:checked').map(function () {
            return $(this).val();
        }).get();

        var cashback_tv = $('input[type="checkbox"][name="step3-2-cb-tv"]:checked').map(function () {
            return $(this).val();
        }).get();

        var cashback_phone = $('input[type="checkbox"][name="step3-2-cb-phone"]:checked').map(function () {
            return $(this).val();
        }).get();

        var allSelected = [].concat(camp_net, camp_mobile, camp_tv, camp_phone, cashback_net, cashback_mobile, cashback_tv, cashback_phone).join('\n\n');

    }

    $('.selected-campaign').text(allSelected);

}

// clear according selected items
function clearLeftResults() {
    if ($('input[type="radio"][name="step1"]:checked').val() == "ご検討のお客さま") {
        if ($('input[type="checkbox"][name="step4"]:checked').length === 0) {
            $('.selected-plan-net').text('－');
            $('.selected-plan-mobile').text('－');
            $('.selected-plan-mobileoption').text('－');
            $('.selected-plan-tv').text('－');
            $('.selected-plan-phone').text('－');
            $('.selected-campaign').text('－');
            $('#month-value').text('0');
            $('#month-value-tax').text('0');

        } else {
            // if (!$('.cbNet').is(':checked')) {
            $('.selected-plan-net').text('－');
            // }

            // if (!$('.cbMobile').is(':checked')) {
            $('.selected-plan-mobile').text('－');
            $('.selected-plan-mobileoption').text('－');
            // }

            // if (!$('.cbTv').is(':checked')) {
            $('.selected-plan-tv').text('－');
            // }

            // if (!$('.cbPhone').is(':checked')) {
            $('.selected-plan-phone').text('－');
            // }

            $('.selected-campaign').text('－');
        }

    } else if ($('input[type="radio"][name="step1"]:checked').val() == "ご利用中のお客さま") {
        if ($('input[type="checkbox"][name="step3-cur"]:checked').length === 0) {
            $('.selected-plan-net').text('');
            $('.selected-plan-mobile').text('');
            $('.selected-plan-mobileoption').text('');
            $('.selected-plan-tv').text('');
            $('.selected-plan-phone').text('');
            $('#month-value-afterchange').text('0');
            $('#month-value-tax-afterchange').text('0');
            $('#month-value-selected').text('0');
            $('#month-value-tax-selected').text('0');
            $('#month-value-diff').text('0');
            $('#month-value-tax-diff').text('0');
            $('.diff-icon').hide();
        } else {
            if (!$('.cbNet').is(':checked')) {
                $('.selected-plan-net').text('');
            }

            if (!$('.cbMobile').is(':checked')) {
                $('.selected-plan-mobile').text('');
                $('.selected-plan-mobileoption').text('');
            }

            if (!$('.cbTv').is(':checked')) {
                $('.selected-plan-tv').text('');
            }

            if (!$('.cbPhone').is(':checked')) {
                $('.selected-plan-phone').text('');
            }
        }

        if ($('input[type="checkbox"][name="step6-cur"]:checked').length === 0) {
            $('.changed-plan-net').text('');
            $('.changed-plan-mobile').text('');
            $('.changed-plan-mobileoption').text('');
            $('.changed-plan-tv').text('');
            $('.changed-plan-phone').text('');

        } else {
            if (!$('.cbNet').is(':checked')) {
                $('.changed-plan-net').text('');
            }

            if (!$('.cbMobile').is(':checked')) {
                $('.changed-plan-mobile').text('');
                $('.changed-plan-mobileoption').text('');
            }

            if (!$('.cbTv').is(':checked')) {
                $('.changed-plan-tv').text('');
            }

            if (!$('.cbPhone').is(':checked')) {
                $('.changed-plan-phone').text('');
            }

        }

        if ($('input[type="checkbox"][name="step7-cur"]:checked').length === 0) {
            $('.changed-plan-net').text('');
            $('.changed-plan-mobile').text('');
            $('.changed-plan-mobileoption').text('');
            $('.changed-plan-tv').text('');
            $('.changed-plan-phone').text('');

        } else {
            if (!$('.cbNet').is(':checked')) {
                $('.changed-plan-net').text('');
            }

            if (!$('.cbMobile').is(':checked')) {
                $('.changed-plan-mobile').text('');
                $('.changed-plan-mobileoption').text('');
            }

            if (!$('.cbTv').is(':checked')) {
                $('.changed-plan-tv').text('');
            }

            if (!$('.cbPhone').is(':checked')) {
                $('.changed-plan-phone').text('');
            }

        }
    }
}

// clear all
function clearAllLeftResults() {
    if ($('input[type="radio"][name="step1"]:checked').val() == "ご検討のお客さま") {
        $('.selected-plan-net').text('－');
        $('.selected-plan-mobile').text('－');
        $('.selected-plan-mobileoption').text('－');
        $('.selected-plan-tv').text('－');
        $('.selected-plan-phone').text('－');
    } else {
        $('.selected-plan-net').text('');
        $('.selected-plan-mobile').text('');
        $('.selected-plan-mobileoption').text('');
        $('.selected-plan-tv').text('');
        $('.selected-plan-phone').text('');
    }

    // $('.selected-plan-net').text('－');
    // $('.selected-plan-mobile').text('－');
    // $('.selected-plan-mobileoption').text('－');
    // $('.selected-plan-tv').text('－');
    // $('.selected-plan-phone').text('－');
    $('.selected-campaign').text('－');
    $('#month-value').text('0');
    $('#month-value-tax').text('0');
    $('.not-selected-plan').show();
    $('#month-value-afterchange').text('0');
    $('#month-value-tax-afterchange').text('0');
    $('#month-value-selected').text('0');
    $('#month-value-tax-selected').text('0');
    $('#month-value-diff').text('0');
    $('#month-value-tax-diff').text('0');
    $('.diff-icon').hide();
    $('.changed-plan-net').text('');
    $('.changed-plan-mobile').text('');
    $('.changed-plan-mobileoption').text('');
    $('.changed-plan-tv').text('');
    $('.changed-plan-phone').text('');
}

function txtToNumber(text) {
    if (text.includes(',')) {
        var val = parseFloat(text.replace(/,/g, ""));
        if (!isNaN(val)) {
            return val;
        } else {
            return 0;
        }
    } else {
        return parseFloat(text);
    }
}

function numberToTxt(number) {
    return Math.round(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function calcTotalByMonth() {
    var total = 0;
    var totaltax = 0;

    var netprice = 0;
    var nettaxprice = 0;

    var mobileprice = 0;
    var mobiletaxprice = 0;

    var mobileopprice = 0;
    var mobileoptaxprice = 0;

    var tvprice = 0;
    var tvtaxprice = 0;

    var phoneprice = 0;
    var phonetaxprice = 0;

    let step2_val = $('input[name="step2"]:checked').val();
    if (step2_val === "戸建住宅") {

        if ($('input[name="step-net-h"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-net-h"]:checked').data("id");
            netprice = txtToNumber($('.net-price-h-' + item).val());
            nettaxprice = netprice * 0.1 + netprice;
        }

        if ($('input[name="step-mobile-h"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-mobile-h"]:checked').data("id");
            mobileprice = txtToNumber($('.mobile-price-h-' + item).val());
            mobiletaxprice = mobileprice * 0.1 + mobileprice;
        }

        if ($('input[name="step-mobileoption-h"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-mobileoption-h"]:checked').data("id");
            mobileopprice = txtToNumber($('.mobileoption-price-h-' + item).val());
            mobileoptaxprice = mobileopprice * 0.1 + mobileopprice;
        }

        if ($('input[name="step-tv-h"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-tv-h"]:checked').data("id");
            tvprice = txtToNumber($('.tv-price-h-' + item).val());
            if ($('input[name="step1"]:checked').val() == "ご利用中のお客さま") {
                tvprice = txtToNumber($('.tv-pricecur-h-' + item).val());
            }
            tvtaxprice = tvprice * 0.1 + tvprice;
        }

        if ($('input[name="step-phone-h"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-phone-h"]:checked').data("id");
            phoneprice = txtToNumber($('.phone-price-h-' + item).val());
            phonetaxprice = phoneprice * 0.1 + phoneprice;
        }

        total = netprice + mobileprice + mobileopprice + tvprice + phoneprice;
        totaltax = nettaxprice + mobiletaxprice + mobileoptaxprice + tvtaxprice + phonetaxprice;

    } else if (step2_val === "集合住宅") {

        if ($('input[name="step-net-m"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-net-m"]:checked').data("id");
            netprice = txtToNumber($('.net-price-m-' + item).val());
            nettaxprice = netprice * 0.1 + netprice;
        }

        if ($('input[name="step-mobile-m"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-mobile-m"]:checked').data("id");
            mobileprice = txtToNumber($('.mobile-price-m-' + item).val());
            mobiletaxprice = mobileprice * 0.1 + mobileprice;
        }

        if ($('input[name="step-mobileoption-m"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-mobileoption-m"]:checked').data("id");
            mobileopprice = txtToNumber($('.mobileoption-price-m-' + item).val());
            mobileoptaxprice = mobileopprice * 0.1 + mobileopprice;
        }

        if ($('input[name="step-tv-m"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-tv-m"]:checked').data("id");
            tvprice = txtToNumber($('.tv-price-m-' + item).val());
            if ($('input[name="step1"]:checked').val() == "ご利用中のお客さま") {
                tvprice = txtToNumber($('.tv-pricecur-m-' + item).val());
            }
            tvtaxprice = tvprice * 0.1 + tvprice;
        }

        if ($('input[name="step-phone-m"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-phone-m"]:checked').data("id");
            phoneprice = txtToNumber($('.phone-price-m-' + item).val());
            phonetaxprice = phoneprice * 0.1 + phoneprice;
        }

        total = netprice + mobileprice + mobileopprice + tvprice + phoneprice;
        totaltax = nettaxprice + mobiletaxprice + mobileoptaxprice + tvtaxprice + phonetaxprice;
    }

    $('#month-value').text(numberToTxt(total));
    $('#month-value-tax').text(numberToTxt(totaltax));

    $('#month-value-selected').text(numberToTxt(total));
    $('#month-value-tax-selected').text(numberToTxt(totaltax));

    $('.aic-simulator__total-val').text($('#month-value').text());
    $('.aic-simulator__total-taxval').text($('#month-value-tax').text());
}

function calcTotalByMonthChange() {
    var total = 0;
    var totaltax = 0;

    var netprice = 0;
    var nettaxprice = 0;

    var mobileprice = 0;
    var mobiletaxprice = 0;

    var mobileopprice = 0;
    var mobileoptaxprice = 0;

    var tvprice = 0;
    var tvtaxprice = 0;

    var phoneprice = 0;
    var phonetaxprice = 0;

    var total_cur = 0;
    var totaltax_cur = 0;

    var netprice_cur = 0;
    var nettaxprice_cur = 0;

    var mobileprice_cur = 0;
    var mobiletaxprice_cur = 0;

    var mobileopprice_cur = 0;
    var mobileoptaxprice_cur = 0;

    var tvprice_cur = 0;
    var tvtaxprice_cur = 0;

    var phoneprice_cur = 0;
    var phonetaxprice_cur = 0;


    let step2_val = $('input[name="step2"]:checked').val();
    if (step2_val === "戸建住宅") {

        if ($('input[name="step-net-h"]:checked').length > 0) {

            // change
            // calc current plan
            item = $('input[type="radio"][name="step-net-h"]:checked').data("id");
            netprice = txtToNumber($('.net-price-h-' + item).val());
            nettaxprice = netprice * 0.1 + netprice;

            netprice_cur = netprice;
            nettaxprice_cur = nettaxprice;

            // set selected to results
            $('.table-current-net').text($('input[type="radio"][name="step-net-h"]:checked').val());
            $('.table-price-current-net').text(numberToTxt(netprice));
            $('.table-taxprice-current-net').text(numberToTxt(nettaxprice));

            // calc change plan
            if ($('#cbNet-cur2').is(':checked')) {
                if ($('input[type="radio"][name="stepchange-net-h"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepchange-net-h"]:checked').data("id");

                    if ($('input[type="radio"][name="stepchange-net-h"]:checked').val() != "なし") {
                        netprice = txtToNumber($('.net-pricechange-h-' + item).val());
                        nettaxprice = netprice * 0.1 + netprice;
                    }

                    // set selected to results
                    $('.table-change-net').text($('input[type="radio"][name="stepchange-net-h"]:checked').val());
                    $('.table-price-change-net').text(numberToTxt(netprice));
                    $('.table-taxprice-change-net').text(numberToTxt(nettaxprice));
                }
            }
        } else {

            // new
            if ($('#cbNet-cur2').is(':checked')) {
                if ($('input[type="radio"][name="stepcur-net-h"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepcur-net-h"]:checked').data("id");
                    netprice = txtToNumber($('.net-price-h-' + item).val());
                    nettaxprice = netprice * 0.1 + netprice;
                }

                // set selected to results
                $('.table-new-net').text($('input[type="radio"][name="stepcur-net-h"]:checked').val());
                $('.table-price-new-net').text(numberToTxt(netprice));
                $('.table-taxprice-new-net').text(numberToTxt(nettaxprice));
            }
        }

        if ($('input[name="step-mobile-h"]:checked').length > 0) {

            // change
            // calc current plan
            item = $('input[type="radio"][name="step-mobile-h"]:checked').data("id");
            mobileprice = txtToNumber($('.mobile-price-h-' + item).val());
            mobiletaxprice = mobileprice * 0.1 + mobileprice;

            mobileprice_cur = mobileprice;
            mobiletaxprice_cur = mobiletaxprice;

            // set selected to table
            $('.table-current-mobile').text($('input[type="radio"][name="step-mobile-h"]:checked').val());
            $('.table-price-current-mobile').text(numberToTxt(mobileprice));
            $('.table-taxprice-current-mobile').text(numberToTxt(mobiletaxprice));


            // calc change plan
            if ($('#cbMobile-cur2').is(':checked')) {
                if ($('input[type="radio"][name="stepchange-mobile-h"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepchange-mobile-h"]:checked').data("id");

                    if ($('input[type="radio"][name="stepchange-mobile-h"]:checked').val() != "なし") {
                        mobileprice = txtToNumber($('.mobile-pricechange-h-' + item).val());
                        mobiletaxprice = mobileprice * 0.1 + mobileprice;
                    }

                    // set selected to results
                    $('.table-change-mobile').text($('input[type="radio"][name="stepchange-mobile-h"]:checked').val());
                    $('.table-price-change-mobile').text(numberToTxt(mobileprice));
                    $('.table-taxprice-change-mobile').text(numberToTxt(mobiletaxprice));

                }
            }
        } else {

            // new
            if ($('#cbMobile-cur2').is(':checked')) {
                if ($('input[type="radio"][name="stepcur-mobile-h"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepcur-mobile-h"]:checked').data("id");
                    mobileprice = txtToNumber($('.mobile-price-h-' + item).val());
                    mobiletaxprice = mobileprice * 0.1 + netprice;
                }

                // set selected to results
                $('.table-new-mobile').text($('input[type="radio"][name="stepcur-mobile-h"]:checked').val());
                $('.table-price-new-mobile').text(numberToTxt(mobileprice));
                $('.table-taxprice-new-mobile').text(numberToTxt(mobiletaxprice));

            }
        }

        if ($('input[name="step-mobileoption-h"]:checked').length > 0) {

            // change
            // calc current plan
            item = $('input[type="radio"][name="step-mobileoption-h"]:checked').data("id");
            mobileopprice = txtToNumber($('.mobileoption-price-h-' + item).val());
            mobileoptaxprice = mobileopprice * 0.1 + mobileopprice;

            mobileopprice_cur = mobileopprice;
            mobileoptaxprice_cur = mobileoptaxprice;

            // set selected to results
            $('.table-current-mobileoption').text($('input[type="radio"][name="step-mobileoption-h"]:checked').val());
            $('.table-price-current-mobileoption').text(numberToTxt(mobileopprice));
            $('.table-taxprice-current-mobileoption').text(numberToTxt(mobileoptaxprice));

            // calc change plan
            if ($('#cbMobile-cur2').is(':checked')) {

                if ($('input[type="radio"][name="stepchange-mobileoption-h"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepchange-mobileoption-h"]:checked').data("id");
                    mobileopprice = txtToNumber($('.mobileoption-pricechange-h-' + item).val());
                    mobileoptaxprice = mobileopprice * 0.1 + mobileopprice;

                    // set selected to results
                    $('.table-change-mobileoption').text($('input[type="radio"][name="stepchange-mobileoption-h"]:checked').val());
                    $('.table-price-change-mobileoption').text(numberToTxt(mobileopprice));
                    $('.table-taxprice-change-mobileoption').text(numberToTxt(mobileoptaxprice));
                }
            }
        } else {

            // new
            if ($('#cbMobile-cur2').is(':checked')) {
                if ($('input[type="radio"][name="stepcur-mobileoption-h"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepcur-mobileoption-h"]:checked').data("id");
                    mobileopprice = txtToNumber($('.mobileoption-price-h-' + item).val());
                    mobileoptaxprice = mobileopprice * 0.1 + mobileopprice;
                }

                // set selected to results
                $('.table-new-mobileoption').text($('input[type="radio"][name="stepcur-mobileoption-h"]:checked').val());
                $('.table-price-new-mobileoption').text(numberToTxt(mobileopprice));
                $('.table-taxprice-new-mobileoption').text(numberToTxt(mobileoptaxprice));
            }
        }

        if ($('input[name="step-tv-h"]:checked').length > 0) {

            // change
            // calc current plan
            item = $('input[type="radio"][name="step-tv-h"]:checked').data("id");
            tvprice = txtToNumber($('.tv-pricecur-h-' + item).val());
            tvtaxprice = tvprice * 0.1 + tvprice;

            tvprice_cur = tvprice;
            tvtaxprice_cur = tvtaxprice_cur;

            // set selected to results
            $('.table-current-tv').text($('input[type="radio"][name="step-tv-h"]:checked').val());
            $('.table-price-current-tv').text(numberToTxt(tvprice));
            $('.table-taxprice-current-tv').text(numberToTxt(tvtaxprice));

            // calc change plan
            if ($('#cbTv-cur2').is(':checked')) {
                if ($('input[type="radio"][name="stepchange-tv-h"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepchange-tv-h"]:checked').data("id");

                    if ($('input[type="radio"][name="stepchange-tv-h"]:checked').val() != "なし") {
                        tvprice = txtToNumber($('.tv-pricechange-h-' + item).val());
                        tvtaxprice = tvprice * 0.1 + tvprice;
                    }

                    // set selected to results
                    $('.table-change-tv').text($('input[type="radio"][name="stepchange-tv-h"]:checked').val());
                    $('.table-price-change-tv').text(numberToTxt(tvprice));
                    $('.table-taxprice-change-tv').text(numberToTxt(tvtaxprice));
                }
            }
        } else {

            // new
            if ($('#cbTv-cur2').is(':checked')) {
                if ($('input[type="radio"][name="stepcur-tv-h"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepcur-tv-h"]:checked').data("id");
                    tvprice = txtToNumber($('.tv-price-h-' + item).val());
                    tvtaxprice = tvprice * 0.1 + tvprice;
                }

                // set selected to results
                $('.table-new-tv').text($('input[type="radio"][name="stepcur-tv-h"]:checked').val());
                $('.table-price-new-tv').text(numberToTxt(tvprice));
                $('.table-taxprice-new-tv').text(numberToTxt(tvtaxprice));
            }
        }

        if ($('input[name="step-phone-h"]:checked').length > 0) {

            // change
            // calc current plan
            item = $('input[type="radio"][name="step-phone-h"]:checked').data("id");
            phoneprice = txtToNumber($('.phone-price-h-' + item).val());
            phonetaxprice = phoneprice * 0.1 + phoneprice;

            phoneprice_cur = phoneprice;
            phonetaxprice_cur = phonetaxprice;

            // set selected to results
            $('.table-current-phone').text($('input[type="radio"][name="step-phone-h"]:checked').val());
            $('.table-price-current-phone').text(numberToTxt(phoneprice));
            $('.table-taxprice-current-phone').text(numberToTxt(phonetaxprice));

            // calc change plan
            if ($('#cbPhone-cur2').is(':checked')) {
                if ($('input[type="radio"][name="stepchange-phone-h"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepchange-phone-h"]:checked').data("id");

                    if ($('input[type="radio"][name="stepchange-phone-h"]:checked').val() != "なし") {
                        phoneprice = txtToNumber($('.phone-pricechange-h-' + item).val());
                        phonetaxprice = phoneprice * 0.1 + phoneprice;
                    }

                    // set selected to results
                    $('.table-change-phone').text($('input[type="radio"][name="stepchange-phone-h"]:checked').val());
                    $('.table-price-change-phone').text(numberToTxt(phoneprice));
                    $('.table-taxprice-change-phone').text(numberToTxt(phonetaxprice));
                }
            }
        } else {

            // new
            if ($('#cbPhone-cur2').is(':checked')) {
                if ($('input[type="radio"][name="stepcur-phone-h"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepcur-phone-h"]:checked').data("id");
                    phoneprice = txtToNumber($('.phone-price-h-' + item).val());
                    phonetaxprice = phoneprice * 0.1 + phoneprice;
                }

                // set selected to results
                $('.table-new-phone').text($('input[type="radio"][name="stepcur-phone-h"]:checked').val());
                $('.table-price-new-phone').text(numberToTxt(phoneprice));
                $('.table-taxprice-new-phone').text(numberToTxt(phonetaxprice));
            }
        }

        total = netprice + mobileprice + mobileopprice + tvprice + phoneprice;
        totaltax = nettaxprice + mobiletaxprice + mobileoptaxprice + tvtaxprice + phonetaxprice;

        total_cur = netprice_cur + mobileprice_cur + mobileopprice_cur + tvprice_cur + phoneprice_cur;
        totaltax_cur = total_cur * 0.1 + total_cur;

        $('#month-value-afterchange').text(numberToTxt(total));
        $('#month-value-tax-afterchange').text(numberToTxt(totaltax));

        changeVal = total;
        currentVal = txtToNumber($('#month-value-selected').text());

        var diff = 0;
        if (changeVal >= currentVal) {
            diff = changeVal - currentVal;
            $('.diff-plus-icon').show();
            $('.diff-minus-icon').hide();
        } else {
            diff = currentVal - changeVal;
            $('.diff-plus-icon').hide();
            $('.diff-minus-icon').show();
        }

        if (diff == 0) {
            $('.diff-plus-icon').hide();
            $('.diff-minus-icon').hide();
        }

        difftax = diff * 0.1 + diff;

        $('#month-value-diff').text(numberToTxt(diff));
        $('#month-value-tax-diff').text(numberToTxt(difftax));


    } else if (step2_val === "集合住宅") {

        if ($('input[name="step-net-m"]:checked').length > 0) {

            // change
            // calc current plan
            item = $('input[type="radio"][name="step-net-m"]:checked').data("id");
            netprice = txtToNumber($('.net-price-m-' + item).val());
            nettaxprice = netprice * 0.1 + netprice;

            netprice_cur = netprice;
            nettaxprice_cur = nettaxprice;

            // set selected to results
            $('.table-current-net').text($('input[type="radio"][name="step-net-m"]:checked').val());
            $('.table-price-current-net').text(numberToTxt(netprice));
            $('.table-taxprice-current-net').text(numberToTxt(nettaxprice));

            // calc change plan
            if ($('#cbNet-cur2').is(':checked')) {
                if ($('input[type="radio"][name="stepchange-net-m"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepchange-net-m"]:checked').data("id");

                    if ($('input[type="radio"][name="stepchange-net-m"]:checked').val() != "なし") {
                        netprice = txtToNumber($('.net-pricechange-m-' + item).val());
                        nettaxprice = netprice * 0.1 + netprice;
                    }

                    // set selected to results
                    $('.table-change-net').text($('input[type="radio"][name="stepchange-net-m"]:checked').val());
                    $('.table-price-change-net').text(numberToTxt(netprice));
                    $('.table-taxprice-change-net').text(numberToTxt(nettaxprice));
                }
            }
        } else {

            // new
            if ($('#cbNet-cur2').is(':checked')) {
                if ($('input[type="radio"][name="stepcur-net-m"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepcur-net-m"]:checked').data("id");
                    netprice = txtToNumber($('.net-price-m-' + item).val());
                    nettaxprice = netprice * 0.1 + netprice;
                }

                // set selected to results
                $('.table-new-net').text($('input[type="radio"][name="stepcur-net-m"]:checked').val());
                $('.table-price-new-net').text(numberToTxt(netprice));
                $('.table-taxprice-new-net').text(numberToTxt(nettaxprice));
            }
        }

        if ($('input[name="step-mobile-m"]:checked').length > 0) {

            // change
            // calc current plan
            item = $('input[type="radio"][name="step-mobile-m"]:checked').data("id");
            mobileprice = txtToNumber($('.mobile-price-m-' + item).val());
            mobiletaxprice = mobileprice * 0.1 + mobileprice;

            mobileprice_cur = mobileprice;
            mobiletaxprice_cur = mobiletaxprice;

            // set selected to results
            $('.table-current-mobile').text($('input[type="radio"][name="step-mobile-m"]:checked').val());
            $('.table-price-current-mobile').text(numberToTxt(mobileprice));
            $('.table-taxprice-current-mobile').text(numberToTxt(mobiletaxprice));

            // calc change plan
            if ($('#cbMobile-cur2').is(':checked')) {
                if ($('input[type="radio"][name="stepchange-mobile-m"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepchange-mobile-m"]:checked').data("id");

                    if ($('input[type="radio"][name="stepchange-mobile-m"]:checked').val() != "なし") {
                        mobileprice = txtToNumber($('.mobile-pricechange-m-' + item).val());
                        mobiletaxprice = mobileprice * 0.1 + mobileprice;
                    }

                    // set selected to results
                    $('.table-change-mobile').text($('input[type="radio"][name="stepchange-mobile-m"]:checked').val());
                    $('.table-price-change-mobile').text(numberToTxt(mobileprice));
                    $('.table-taxprice-change-mobile').text(numberToTxt(mobiletaxprice));
                }
            }
        } else {

            // new
            if ($('#cbMobile-cur2').is(':checked')) {
                if ($('input[type="radio"][name="stepcur-mobile-m"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepcur-mobile-m"]:checked').data("id");
                    mobileprice = txtToNumber($('.mobile-price-m-' + item).val());
                    mobiletaxprice = mobileprice * 0.1 + netprice;
                }

                // set selected to results
                $('.table-new-mobile').text($('input[type="radio"][name="stepcur-mobile-m"]:checked').val());
                $('.table-price-new-mobile').text(numberToTxt(mobileprice));
                $('.table-taxprice-new-mobile').text(numberToTxt(mobiletaxprice));
            }
        }

        if ($('input[name="step-mobileoption-m"]:checked').length > 0) {

            // change
            // calc current plan
            item = $('input[type="radio"][name="step-mobileoption-m"]:checked').data("id");
            mobileopprice = txtToNumber($('.mobileoption-price-m-' + item).val());
            mobileoptaxprice = mobileopprice * 0.1 + mobileopprice;

            mobileopprice_cur = mobileopprice;
            mobileoptaxprice_cur = mobileoptaxprice;

            // set selected to results
            $('.table-current-mobileoption').text($('input[type="radio"][name="step-mobileoption-m"]:checked').val());
            $('.table-price-current-mobileoption').text(numberToTxt(mobileopprice));
            $('.table-taxprice-current-mobileoption').text(numberToTxt(mobileoptaxprice));

            // calc change plan
            if ($('#cbMobile-cur2').is(':checked')) {
                if ($('input[type="radio"][name="stepchange-mobileoption-m"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepchange-mobileoption-m"]:checked').data("id");
                    mobileopprice = txtToNumber($('.mobileoption-pricechange-m-' + item).val());
                    mobileoptaxprice = mobileopprice * 0.1 + mobileopprice;

                    // set selected to results
                    $('.table-change-mobileoption').text($('input[type="radio"][name="stepchange-mobileoption-m"]:checked').val());
                    $('.table-price-change-mobileoption').text(numberToTxt(mobileopprice));
                    $('.table-taxprice-change-mobileoption').text(numberToTxt(mobileoptaxprice));
                }
            }
        } else {

            // new
            if ($('#cbMobile-cur2').is(':checked')) {
                if ($('input[type="radio"][name="stepcur-mobileoption-m"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepcur-mobileoption-m"]:checked').data("id");
                    mobileopprice = txtToNumber($('.mobileoption-price-m-' + item).val());
                    mobileoptaxprice = mobileopprice * 0.1 + mobileopprice;
                }

                // set selected to results
                $('.table-new-mobileoption').text($('input[type="radio"][name="stepcur-mobileoption-m"]:checked').val());
                $('.table-price-new-mobileoption').text(numberToTxt(mobileopprice));
                $('.table-taxprice-new-mobileoption').text(numberToTxt(mobileoptaxprice));
            }
        }

        if ($('input[name="step-tv-m"]:checked').length > 0) {

            // change
            // calc current plan
            item = $('input[type="radio"][name="step-tv-m"]:checked').data("id");
            tvprice = txtToNumber($('.tv-pricecur-m-' + item).val());
            tvtaxprice = tvprice * 0.1 + tvprice;

            tvprice_cur = tvprice;
            tvtaxprice_cur = tvtaxprice_cur;

            // set selected to results
            $('.table-current-tv').text($('input[type="radio"][name="step-tv-m"]:checked').val());
            $('.table-price-current-tv').text(numberToTxt(tvprice));
            $('.table-taxprice-current-tv').text(numberToTxt(tvtaxprice));

            // calc change plan
            if ($('#cbTv-cur2').is(':checked')) {
                if ($('input[type="radio"][name="stepchange-tv-m"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepchange-tv-m"]:checked').data("id");

                    if ($('input[type="radio"][name="stepchange-tv-m"]:checked').val() != "なし") {
                        tvprice = txtToNumber($('.tv-pricechange-m-' + item).val());
                        tvtaxprice = tvprice * 0.1 + tvprice;
                    }

                    // set selected to results
                    $('.table-change-tv').text($('input[type="radio"][name="stepchange-tv-m"]:checked').val());
                    $('.table-price-change-tv').text(numberToTxt(tvprice));
                    $('.table-taxprice-change-tv').text(numberToTxt(tvtaxprice));

                }
            }
        } else {

            // new
            if ($('#cbTv-cur2').is(':checked')) {
                if ($('input[type="radio"][name="stepcur-tv-m"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepcur-tv-m"]:checked').data("id");
                    tvprice = txtToNumber($('.tv-price-m-' + item).val());
                    tvtaxprice = tvprice * 0.1 + tvprice;
                }

                // set selected to results
                $('.table-new-tv').text($('input[type="radio"][name="stepcur-tv-m"]:checked').val());
                $('.table-price-new-tv').text(numberToTxt(tvprice));
                $('.table-taxprice-new-tv').text(numberToTxt(tvtaxprice));
            }
        }

        if ($('input[name="step-phone-m"]:checked').length > 0) {

            // change
            // calc current plan
            item = $('input[type="radio"][name="step-phone-m"]:checked').data("id");
            phoneprice = txtToNumber($('.phone-price-m-' + item).val());
            phonetaxprice = phoneprice * 0.1 + phoneprice;

            phoneprice_cur = phoneprice;
            phonetaxprice_cur = phonetaxprice;

            // set selected to results
            $('.table-current-phone').text($('input[type="radio"][name="step-phone-m"]:checked').val());
            $('.table-price-current-phone').text(numberToTxt(phoneprice));
            $('.table-taxprice-current-phone').text(numberToTxt(phonetaxprice));

            // calc change plan
            if ($('#cbPhone-cur2').is(':checked')) {
                if ($('input[type="radio"][name="stepchange-phone-m"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepchange-phone-m"]:checked').data("id");

                    if ($('input[type="radio"][name="stepchange-phone-m"]:checked').val() != "なし") {
                        phoneprice = txtToNumber($('.phone-pricechange-m-' + item).val());
                        phonetaxprice = phoneprice * 0.1 + phoneprice;
                    }

                    // set selected to results
                    $('.table-change-phone').text($('input[type="radio"][name="stepchange-phone-m"]:checked').val());
                    $('.table-price-change-phone').text(numberToTxt(phoneprice));
                    $('.table-taxprice-change-phone').text(numberToTxt(phonetaxprice));
                }
            }
        } else {

            // new
            if ($('#cbPhone-cur2').is(':checked')) {
                if ($('input[type="radio"][name="stepcur-phone-m"]:checked').length > 0) {
                    item = $('input[type="radio"][name="stepcur-phone-m"]:checked').data("id");
                    phoneprice = txtToNumber($('.phone-price-m-' + item).val());
                    phonetaxprice = phoneprice * 0.1 + phoneprice;
                }

                // set selected to results
                $('.table-new-phone').text($('input[type="radio"][name="stepcur-phone-m"]:checked').val());
                $('.table-price-new-phone').text(numberToTxt(phoneprice));
                $('.table-taxprice-new-phone').text(numberToTxt(phonetaxprice));
            }
        }

        total = netprice + mobileprice + mobileopprice + tvprice + phoneprice;
        totaltax = nettaxprice + mobiletaxprice + mobileoptaxprice + tvtaxprice + phonetaxprice;

        total_cur = netprice_cur + mobileprice_cur + mobileopprice_cur + tvprice_cur + phoneprice_cur;
        totaltax_cur = total_cur * 0.1 + total_cur;

        $('#month-value-afterchange').text(numberToTxt(total));
        $('#month-value-tax-afterchange').text(numberToTxt(totaltax));

        changeVal = total;
        currentVal = txtToNumber($('#month-value-selected').text());

        var diff = 0;
        if (changeVal >= currentVal) {
            diff = changeVal - currentVal;
            $('.diff-plus-icon').show();
            $('.diff-minus-icon').hide();
        } else {
            diff = currentVal - changeVal;
            $('.diff-plus-icon').hide();
            $('.diff-minus-icon').show();
        }

        if (diff == 0) {
            $('.diff-plus-icon').hide();
            $('.diff-minus-icon').hide();
        }

        difftax = diff * 0.1 + diff;

        $('#month-value-diff').text(numberToTxt(diff));
        $('#month-value-tax-diff').text(numberToTxt(difftax));

    }

    // simulator results
    $('.aic-simulator__total-val').text($('#month-value-afterchange').text());
    $('.aic-simulator__total-taxval').text($('#month-value-tax-afterchange').text());

    $('.aic-simulator__totalcurrent-val').text(numberToTxt(total_cur));
    $('.aic-simulator__totalcurrent-taxval').text(numberToTxt(totaltax_cur));

}

function setLeftResults(service) {

    let step2_val = $('input[name="step2"]:checked').val();
    if (step2_val === "戸建住宅") {
        var id = $('input[type="radio"][name="step-' + service + '-h"]:checked').data('id');

        price = txtToNumber($('.' + service + '-price-h-' + id).val());
        if ($('input[name="step1"]:checked').val() == "ご利用中のお客さま" && service == "tv") {
            price = txtToNumber($('.' + service + '-pricecur-h-' + id).val());
        }
        var taxprice = price * 0.1 + price;
        var plan = $('input[type="radio"][name="step-' + service + '-h"]:checked').val();

        $('.selected-plan-' + service).html(plan + '<br>' + '月額' + numberToTxt(price) + '円(税込' + numberToTxt(taxprice) + '円)');

        if (service === "mobileoption") {
            $('.selected-plan-' + service).html(plan + '<br>' + '月額' + numberToTxt(price) + '円(税込' + numberToTxt(taxprice) + '円)');
        }
    } else {
        var id = $('input[type="radio"][name="step-' + service + '-m"]:checked').data('id');

        price = txtToNumber($('.' + service + '-price-m-' + id).val());
        if ($('input[name="step1"]:checked').val() == "ご利用中のお客さま" && service == "tv") {
            price = txtToNumber($('.' + service + '-pricecur-m-' + id).val());
        }
        var taxprice = price * 0.1 + price;
        var plan = $('input[type="radio"][name="step-' + service + '-m"]:checked').val();

        $('.selected-plan-' + service).html(plan + '<br>' + '月額' + numberToTxt(price) + '円(税込' + numberToTxt(taxprice) + '円)');

        if (service === "mobileoption") {
            $('.selected-plan-' + service).html(plan + '<br>' + '月額' + numberToTxt(price) + '円(税込' + numberToTxt(taxprice) + '円)');
        }
    }
}

function setLeftResultsChange(service, step) {

    let step2_val = $('input[name="step2"]:checked').val();

    if (step2_val === "戸建住宅") {
        var id = $('input[type="radio"][name="' + step + '-' + service + '-h"]:checked').data('id');

        price = txtToNumber($('.' + service + '-price-h-' + id).val());
        var taxprice = price * 0.1 + price;
        var plan = $('input[type="radio"][name="' + step + '-' + service + '-h"]:checked').val();

        $('.changed-plan-' + service).html(plan + '<br>' + '月額' + numberToTxt(price) + '円(税込' + numberToTxt(taxprice) + '円)');

        if (service === "mobileoption") {
            $('.changed-plan-' + service).html(plan + '<br>' + '月額' + numberToTxt(price) + '円(税込' + numberToTxt(taxprice) + '円)');
        }
    } else {
        var id = $('input[type="radio"][name="' + step + '-' + service + '-m"]:checked').data('id');

        price = txtToNumber($('.' + service + '-price-m-' + id).val());
        var taxprice = price * 0.1 + price;
        var plan = $('input[type="radio"][name="' + step + '-' + service + '-m"]:checked').val();

        $('.changed-plan-' + service).html(plan + '<br>' + '月額' + numberToTxt(price) + '円(税込' + numberToTxt(taxprice) + '円)');

        if (service === "mobileoption") {
            $('.changed-plan-' + service).html(plan + '<br>' + '月額' + numberToTxt(price) + '円(税込' + numberToTxt(taxprice) + '円)');
        }
    }
}

// ------------------------------
// 下のシミュレーター結果
// ------------------------------
function calcCampaign() {
    var discount = 0;
    var taxdiscount = 0;

    let step2_val = $('input[type="radio"][name="step2"]:checked').val();
    if (step2_val === "戸建住宅") {

        $('input[type="checkbox"][name="step3-1"]').each(function () {
            if ($(this).is(':checked')) {
                var id = $(this).data('id');

                discount += txtToNumber($('.campaign-discount-h-' + id).val()) * $('.campaign-months-h-' + id).val();
                taxdiscount += discount * 0.1 + discount;
            }
        });

        return discount;

    } else if (step2_val === "集合住宅") {

        $('input[type="checkbox"][name="step3-2"]').each(function () {
            if ($(this).is(':checked')) {
                var id = $(this).data('id');

                discount += txtToNumber($('.campaign-discount-m-' + id).val()) * $('.campaign-months-m-' + id).val();
                taxdiscount += discount * 0.1 + discount;

            }
        });

        return discount;


    }
}

function calcTotalByYear() {
    var total = 0;
    var totaltax = 0;

    var netprice = 0;
    var nettaxprice = 0;

    var mobileprice = 0;
    var mobiletaxprice = 0;

    var mobileopprice = 0;
    var mobileoptaxprice = 0;

    var tvprice = 0;
    var tvtaxprice = 0;

    var phoneprice = 0;
    var phonetaxprice = 0;

    let step2_val = $('input[name="step2"]:checked').val();
    if (step2_val === "戸建住宅") {

        if ($('input[name="step-net-h"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-net-h"]:checked').data("id");
            netprice = txtToNumber($('.net-price-h-' + item).val());
            nettaxprice = netprice * 0.1 + netprice;
        }

        if ($('input[name="step-mobile-h"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-mobile-h"]:checked').data("id");
            mobileprice = txtToNumber($('.mobile-price-h-' + item).val());
            mobiletaxprice = mobileprice * 0.1 + mobileprice;
        }

        if ($('input[name="step-mobileoption-h"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-mobileoption-h"]:checked').data("id");
            mobileopprice = txtToNumber($('.mobileoption-price-h-' + item).val());
            mobileoptaxprice = mobileopprice * 0.1 + mobileopprice;
        }

        if ($('input[name="step-tv-h"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-tv-h"]:checked').data("id");
            tvprice = txtToNumber($('.tv-price-h-' + item).val());
            tvtaxprice = tvprice * 0.1 + tvprice;
        }

        if ($('input[name="step-phone-h"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-phone-h"]:checked').data("id");
            phoneprice = txtToNumber($('.phone-price-h-' + item).val());
            phonetaxprice = phoneprice * 0.1 + phoneprice;
        }

        total = ((netprice + mobileprice + mobileopprice + tvprice + phoneprice) * 12) - calcCampaign();
        campaigntax = calcCampaign() * 0.1 + calcCampaign();
        totaltax = ((nettaxprice + mobiletaxprice + mobileoptaxprice + tvtaxprice + phonetaxprice) * 12) - campaigntax;

        $('#ycvprice-year').text(numberToTxt(total));
        $('#ycvtaxprice-year').text(numberToTxt(totaltax));

        return total;

    } else if (step2_val === "集合住宅") {

        if ($('input[name="step-net-m"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-net-m"]:checked').data("id");
            netprice = txtToNumber($('.net-price-m-' + item).val());
            nettaxprice = netprice * 0.1 + netprice;
        }

        if ($('input[name="step-mobile-m"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-mobile-m"]:checked').data("id");
            mobileprice = txtToNumber($('.mobile-price-m-' + item).val());
            mobiletaxprice = mobileprice * 0.1 + mobileprice;
        }

        if ($('input[name="step-mobileoption-m"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-mobileoption-m"]:checked').data("id");
            mobileopprice = txtToNumber($('.mobileoption-price-m-' + item).val());
            mobileoptaxprice = mobileopprice * 0.1 + mobileopprice;
        }

        if ($('input[name="step-tv-m"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-tv-m"]:checked').data("id");
            tvprice = txtToNumber($('.tv-price-m-' + item).val());
            tvtaxprice = tvprice * 0.1 + tvprice;
        }

        if ($('input[name="step-phone-m"]:checked').length > 0) {
            item = $('input[type="radio"][name="step-phone-m"]:checked').data("id");
            phoneprice = txtToNumber($('.phone-price-m-' + item).val());
            phonetaxprice = phoneprice * 0.1 + phoneprice;
        }

        total = ((netprice + mobileprice + mobileopprice + tvprice + phoneprice) * 12) - calcCampaign();
        campaigntax = calcCampaign() * 0.1 + calcCampaign();
        totaltax = ((nettaxprice + mobiletaxprice + mobileoptaxprice + tvtaxprice + phonetaxprice) * 12) - campaigntax;

        $('#ycvprice-year').text(numberToTxt(total));
        $('#ycvtaxprice-year').text(numberToTxt(totaltax));

        return total;
    }
}

function calcCurrentByYear() {
    var total = txtToNumber($('#currentprice').val()) * 12;
    var taxtotal = total * 0.1 + total;

    $('#currentprice-year').text(numberToTxt(total));
    $('#currenttaxprice-year').text(numberToTxt(taxtotal));

    return total;
}

function calcDiff() {
    var difftotal = calcCurrentByYear() - calcTotalByYear();
    var difftaxtotal = difftotal * 0.1 + difftotal;

    $('#diffprice-year').text(numberToTxt(difftotal));
    $('#difftaxprice-year').text(numberToTxt(difftaxtotal));
}

function diffGreater0() {
    var difftotal = calcCurrentByYear() - calcTotalByYear();

    if (difftotal > 0) {
        return true;
    } else {
        return false;
    }
}

function showSelectedResults() {
    // current
    if ($('#cbNet-cur').is(':checked')) {
        let step2_val = $('input[name="step2"]:checked').val();
        if (step2_val === "戸建住宅") {
            if ($('input[name="step-net-h"]:checked').length > 0) {
                $('.row-current-net').addClass('active-row');

                var id = $('input[name="step-net-h"]:checked').data('id');
                var price = $('.net-price-h-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="step-net-h"]:checked').val().trim();

                newchangeResultsSetCampaign('net', id, price, taxprice, 'current', plan);

            } else {
                $('.row-current-net').removeClass('active-row');
            }
        } else {
            if ($('input[name="step-net-m"]:checked').length > 0) {
                var id = $('input[name="step-net-m"]:checked').data('id');
                var price = $('.net-price-m-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="step-net-m"]:checked').val().trim();

                newchangeResultsSetCampaign('net', id, price, taxprice, 'current', plan);
                $('.row-current-net').addClass('active-row');
            } else {
                $('.row-current-net').removeClass('active-row');
            }
        }
    } else {
        $('.row-current-net').removeClass('active-row');
    }

    if ($('#cbMobile-cur').is(':checked')) {
        // 戸建住宅
        let step2_val = $('input[name="step2"]:checked').val();
        if (step2_val === "戸建住宅") {


            if ($('input[name="step-mobile-h"]:checked').length > 0) {
                $('.row-current-mobile').addClass('active-row');
                var id = $('input[name="step-mobile-h"]:checked').data('id');
                var price = $('.mobile-price-h-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="step-mobile-h"]:checked').val().trim();

                newchangeResultsSetCampaign('mobile', id, price, taxprice, 'current', plan);

            } else {
                $('.row-current-mobile').removeClass('active-row');
            }

            if ($('input[type="radio"][name="step-mobileoption-h"]:checked').length > 0) {
                $('.row-current-mobileoption').addClass('active-row');
            } else {
                $('.row-current-mobileoption').removeClass('active-row');
            }
        } else {

            // 集合住宅
            if ($('input[type="radio"][name="step-mobile-m"]:checked').length > 0) {
                $('.row-current-mobile').addClass('active-row');
                var id = $('input[name="step-mobile-m"]:checked').data('id');
                var price = $('.mobile-price-m-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="step-mobile-m"]:checked').val().trim();

                newchangeResultsSetCampaign('mobile', id, price, taxprice, 'current', plan);
            } else {
                $('.row-current-mobile').removeClass('active-row');
            }

            if ($('input[type="radio"][name="step-mobileoption-m"]:checked').length > 0) {
                $('.row-current-mobileoption').addClass('active-row');
            } else {
                $('.row-current-mobileoption').removeClass('active-row');
            }
        }
    } else {
        $('.row-current-mobile').removeClass('active-row');
    }

    if ($('#cbTv-cur').is(':checked')) {

        step2_val = $('input[name="step2"]:checked').val();
        if (step2_val === "戸建住宅") {
            if ($('input[name="step-tv-h"]:checked').length > 0) {
                $('.row-current-tv').addClass('active-row');
                var id = $('input[name="step-tv-h"]:checked').data('id');
                var price = $('.tv-pricechange-h-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="step-tv-h"]:checked').val().trim();

                newchangeResultsSetCampaign('tv', id, price, taxprice, 'current', plan);
            } else {
                $('.row-current-tv').removeClass('active-row');
            }
        } else {
            if ($('input[name="step-tv-m"]:checked').length > 0) {
                $('.row-current-tv').addClass('active-row');
                var id = $('input[name="step-tv-m"]:checked').data('id');
                var price = $('.tv-pricechange-m-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="step-tv-m"]:checked').val().trim();

                newchangeResultsSetCampaign('tv', id, price, taxprice, 'current', plan);
            } else {
                $('.row-current-tv').removeClass('active-row');
            }
        }

    } else {
        $('.row-current-tv').removeClass('active-row');
    }

    if ($('#cbPhone-cur').is(':checked')) {

        step2_val = $('input[name="step2"]:checked').val();
        if (step2_val === "戸建住宅") {
            if ($('input[name="step-phone-h"]:checked').length > 0) {
                $('.row-current-phone').addClass('active-row');
                var id = $('input[name="step-phone-h"]:checked').data('id');
                var price = $('.phone-price-h-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="step-phone-h"]:checked').val().trim();

                newchangeResultsSetCampaign('phone', id, price, taxprice, 'current', plan);
            } else {
                $('.row-current-phone').removeClass('active-row');
            }
        } else {
            if ($('input[name="step-phone-m"]:checked').length > 0) {
                $('.row-current-phone').addClass('active-row');
                var id = $('input[name="step-phone-m"]:checked').data('id');
                var price = $('.phone-price-m-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="step-phone-m"]:checked').val().trim();

                newchangeResultsSetCampaign('phone', id, price, taxprice, 'current', plan);
            } else {
                $('.row-current-phone').removeClass('active-row');
            }
        }

    } else {
        $('.row-current-phone').removeClass('active-row');
    }


    // new
    if (!$('#cbNet-cur').is(':checked') && $('#cbNet-cur2').is(':checked')) {
        step2_val = $('input[name="step2"]:checked').val();
        if (step2_val === "戸建住宅") {
            if ($('input[name="stepcur-net-h"]:checked').length > 0) {
                $('.row-new-net').addClass('active-row');
                var id = $('input[name="stepcur-net-h"]:checked').data('id');
                var price = $('.net-price-h-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="stepcur-net-h"]:checked').val().trim();

                newchangeResultsSetCampaign('net', id, price, taxprice, 'new', plan);
            } else {
                $('.row-new-net').removeClass('active-row');
            }
        } else {
            if ($('input[name="stepcur-net-m"]:checked').length > 0) {
                $('.row-new-net').addClass('active-row');
                var id = $('input[name="stepcur-net-m"]:checked').data('id');
                var price = $('.net-price-m-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="stepcur-net-m"]:checked').val().trim();
                newchangeResultsSetCampaign('net', id, price, taxprice, 'new', plan);
            } else {
                $('.row-new-net').removeClass('active-row');
            }
        }
    } else {
        $('.row-new-net').removeClass('active-row');
    }

    if (!$('#cbMobile-cur').is(':checked') && $('#cbMobile-cur2').is(':checked')) {
        // 戸建住宅
        let step2_val = $('input[name="step2"]:checked').val();
        if (step2_val === "戸建住宅") {

            if ($('input[type="radio"][name="stepcur-mobile-h"]:checked').length > 0) {
                $('.row-new-mobile').addClass('active-row');
                var id = $('input[name="stepcur-mobile-h"]:checked').data('id');
                var price = $('.mobile-price-h-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="stepcur-mobile-h"]:checked').val().trim();

                newchangeResultsSetCampaign('mobile', id, price, taxprice, 'new', plan);
            } else {
                $('.row-current-res-mobile').addClass('active-row');
                $('.row-new-mobile').removeClass('active-row');
            }

            if ($('input[type="radio"][name="stepcur-mobileoption-h"]:checked').length > 0) {
                $('.row-current-res-mobileoption').removeClass('active-row');
                $('.row-new-mobileoption').addClass('active-row');
            } else {
                $('.row-current-res-mobileoption').addClass('active-row');
                $('.row-new-mobileoption').removeClass('active-row');
            }
        } else {
            // 集合住宅
            if ($('input[type="radio"][name="stepcur-mobile-m"]:checked').length > 0) {
                $('.row-new-mobile').addClass('active-row');
                var id = $('input[name="stepcur-mobile-m"]:checked').data('id');
                var price = $('.mobile-price-m-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="stepcur-mobile-m"]:checked').val().trim();

                newchangeResultsSetCampaign('mobile', id, price, taxprice, 'new', plan);
            } else {
                $('.row-new-mobile').removeClass('active-row');
            }

            if ($('input[type="radio"][name="stepcur-mobileoption-m"]:checked').length > 0) {
                $('.row-current-res-mobileoption').removeClass('active-row');
                $('.row-new-mobileoption').addClass('active-row');
            } else {
                $('.row-current-res-mobileoption').addClass('active-row');
                $('.row-new-mobileoption').removeClass('active-row');
            }
        }

    } else {
        $('.row-new-mobile').removeClass('active-row');
    }

    if (!$('#cbTv-cur').is(':checked') && $('#cbTv-cur2').is(':checked')) {
        step2_val = $('input[name="step2"]:checked').val();
        if (step2_val === "戸建住宅") {
            if ($('input[name="stepcur-tv-h"]:checked').length > 0) {
                $('.row-new-tv').addClass('active-row');
                var id = $('input[name="stepcur-tv-h"]:checked').data('id');
                var price = $('.tv-price-h-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="stepcur-tv-h"]:checked').val().trim();

                newchangeResultsSetCampaign('tv', id, price, taxprice, 'new', plan);
            } else {
                $('.row-new-tv').removeClass('active-row');
            }
        } else {
            if ($('input[name="stepcur-tv-m"]:checked').length > 0) {
                $('.row-new-tv').addClass('active-row');
                var id = $('input[name="stepcur-tv-m"]:checked').data('id');
                var price = $('.tv-price-m-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="stepcur-tv-m"]:checked').val().trim();

                newchangeResultsSetCampaign('tv', id, price, taxprice, 'new', plan);
            } else {
                $('.row-new-tv').removeClass('active-row');
            }
        }

    } else {
        $('.row-new-tv').removeClass('active-row');
    }

    if (!$('#cbPhone-cur').is(':checked') && $('#cbPhone-cur2').is(':checked')) {

        step2_val = $('input[name="step2"]:checked').val();
        if (step2_val === "戸建住宅") {
            if ($('input[name="stepcur-phone-h"]:checked').length > 0) {
                $('.row-new-phone').addClass('active-row');
                var id = $('input[name="stepcur-phone-h"]:checked').data('id');
                var price = $('.phone-price-h-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="stepcur-phone-h"]:checked').val().trim();

                newchangeResultsSetCampaign('phone', id, price, taxprice, 'new', plan);
            } else {
                $('.row-new-phone').removeClass('active-row');
            }
        } else {
            if ($('input[name="stepcur-phone-m"]:checked').length > 0) {
                $('.row-new-phone').addClass('active-row');
                var id = $('input[name="stepcur-phone-m"]:checked').data('id');
                var price = $('.phone-price-m-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="stepcur-phone-m"]:checked').val().trim();

                newchangeResultsSetCampaign('phone', id, price, taxprice, 'new', plan);
            } else {
                $('.row-new-phone').removeClass('active-row');
            }
        }

    } else {
        $('.row-new-phone').removeClass('active-row');
    }


    // change
    if ($('#cbNet-cur').is(':checked') && $('#cbNet-cur2').is(':checked')) {

        step2_val = $('input[name="step2"]:checked').val();
        if (step2_val === "戸建住宅") {
            if ($('input[name="stepchange-net-h"]:checked').length > 0 && $('input[name="stepchange-net-h"]:checked').val() != "なし") {
                $('.row-current-res-net').removeClass('active-row');
                $('.row-change-net').addClass('active-row');
                var id = $('input[name="stepchange-net-h"]:checked').data('id');
                var price = $('.net-price-h-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="stepchange-net-h"]:checked').val().trim();


                newchangeResultsSetCampaign('net', id, price, taxprice, 'change', plan);
                showhideResultschange('stepchange', 'net');
            } else {
                $('.row-current-res-net').addClass('active-row');
                $('.row-change-net').removeClass('active-row');
            }
        } else {
            if ($('input[name="stepchange-net-m"]:checked').length > 0 && $('input[name="stepchange-net-m"]:checked').val() != "なし") {
                $('.row-current-res-net').removeClass('active-row');
                $('.row-change-net').addClass('active-row');
                var id = $('input[name="stepchange-net-m"]:checked').data('id');
                var price = $('.net-price-m-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="stepchange-net-m"]:checked').val().trim();

                newchangeResultsSetCampaign('net', id, price, taxprice, 'change', plan);
                showhideResultschange('stepchange', 'net');

            } else {
                $('.row-current-res-net').addClass('active-row');
                $('.row-change-net').removeClass('active-row');
            }
        }

    } else {
        $('.row-change-net').removeClass('active-row');
    }

    if ($('#cbMobile-cur').is(':checked') && $('#cbMobile-cur2').is(':checked')) {
        // 戸建住宅
        let step2_val = $('input[name="step2"]:checked').val();
        if (step2_val === "戸建住宅") {
            if ($('input[type="radio"][name="stepchange-mobile-h"]:checked').length > 0 && $('input[name="stepchange-mobile-h"]:checked').val() != "なし") {
                $('.row-current-res-mobile').removeClass('active-row');
                $('.row-change-mobile').addClass('active-row');
                var id = $('input[name="stepchange-mobile-h"]:checked').data('id');
                var price = $('.mobile-price-h-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="stepchange-mobile-h"]:checked').val().trim();

                newchangeResultsSetCampaign('mobile', id, price, taxprice, 'change', plan);
                showhideResultschange('stepchange', 'mobile');
            } else {
                $('.row-current-res-mobile').addClass('active-row');
                $('.row-change-mobile').removeClass('active-row');
            }

            if ($('input[type="radio"][name="stepchange-mobileoption-h"]:checked').length > 0) {
                $('.row-current-res-mobileoption').removeClass('active-row');
                $('.row-change-mobileoption').addClass('active-row');

            } else {
                $('.row-current-res-mobileoption').addClass('active-row');
                $('.row-change-mobileoption').removeClass('active-row');
            }
        } else {
            // 集合住宅
            if ($('input[type="radio"][name="stepchange-mobile-m"]:checked').length > 0 && $('input[name="stepchange-mobile-m"]:checked').val() != "なし") {
                $('.row-current-res-mobile').removeClass('active-row');
                $('.row-change-mobile').addClass('active-row');
                var id = $('input[name="stepchange-mobile-m"]:checked').data('id');
                var price = $('.mobile-price-m-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="stepchange-mobile-m"]:checked').val().trim();

                newchangeResultsSetCampaign('mobile', id, price, taxprice, 'change', plan);
                showhideResultschange('stepchange', 'mobile');

            } else {
                $('.row-current-res-mobile').addClass('active-row');
                $('.row-change-mobile').removeClass('active-row');
            }

            if ($('input[type="radio"][name="stepchange-mobileoption-m"]:checked').length > 0) {
                $('.row-current-res-mobileoption').removeClass('active-row');
                $('.row-change-mobileoption').addClass('active-row');
            } else {
                $('.row-current-res-mobileoption').addClass('active-row');
                $('.row-change-mobileoption').removeClass('active-row');
            }
        }

    } else {
        $('.row-change-mobile').removeClass('active-row');
    }

    if ($('#cbTv-cur').is(':checked') && $('#cbTv-cur2').is(':checked')) {

        step2_val = $('input[name="step2"]:checked').val();
        if (step2_val === "戸建住宅") {
            if ($('input[name="stepchange-tv-h"]:checked').length > 0 && $('input[name="stepchange-tv-h"]:checked').val() != "なし") {
                $('.row-current-res-tv').removeClass('active-row');
                $('.row-change-tv').addClass('active-row');
                var id = $('input[name="stepchange-tv-h"]:checked').data('id');
                var price = $('.tv-price-h-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="stepchange-tv-h"]:checked').val().trim();

                newchangeResultsSetCampaign('tv', id, price, taxprice, 'change', plan);
                showhideResultschange('stepchange', 'tv');

            } else {
                $('.row-current-res-tv').addClass('active-row');
                $('.row-change-tv').removeClass('active-row');
            }
        } else {
            if ($('input[name="stepchange-tv-m"]:checked').length > 0 && $('input[name="stepchange-tv-m"]:checked').val() != "なし") {
                $('.row-current-res-tv').removeClass('active-row');
                $('.row-change-tv').addClass('active-row');
                var id = $('input[name="stepchange-tv-m"]:checked').data('id');
                var price = $('.tv-price-m-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="stepchange-tv-m"]:checked').val().trim();

                newchangeResultsSetCampaign('tv', id, price, taxprice, 'change', plan);
                showhideResultschange('stepchange', 'tv');

            } else {
                $('.row-current-res-tv').addClass('active-row');
                $('.row-change-tv').removeClass('active-row');
            }
        }

    } else {
        $('.row-change-tv').removeClass('active-row');
    }

    if ($('#cbPhone-cur').is(':checked') && $('#cbPhone-cur2').is(':checked')) {
        step2_val = $('input[name="step2"]:checked').val();
        if (step2_val === "戸建住宅") {
            if ($('input[name="stepchange-phone-h"]:checked').length > 0 && $('input[name="stepchange-phone-h"]:checked').val() != "なし") {
                $('.row-current-res-phone').removeClass('active-row');
                $('.row-change-phone').addClass('active-row');
                var id = $('input[name="stepchange-phone-h"]:checked').data('id');
                var price = $('.phone-price-h-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="stepchange-phone-h"]:checked').val().trim();

                newchangeResultsSetCampaign('phone', id, price, taxprice, 'change', plan);
                showhideResultschange('stepchange', 'phone');

            } else {
                $('.row-current-res-phone').addClass('active-row');
                $('.row-change-phone').removeClass('active-row');
            }
        } else {
            if ($('input[name="stepchange-phone-m"]:checked').length > 0 && $('input[name="stepchange-phone-m"]:checked').val() != "なし") {
                $('.row-current-res-phone').removeClass('active-row');
                $('.row-change-phone').addClass('active-row');
                var id = $('input[name="stepchange-phone-m"]:checked').data('id');
                var price = $('.phone-price-m-' + id).val();
                var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);

                var plan = $('input[type="radio"][name="stepchange-phone-m"]:checked').val().trim();

                newchangeResultsSetCampaign('phone', id, price, taxprice, 'change', plan);
                showhideResultschange('stepchange', 'phone');

            } else {
                $('.row-current-res-phone').addClass('active-row');
                $('.row-change-phone').removeClass('active-row');
            }
        }
    } else {
        $('.row-change-phone').removeClass('active-row');
    }
}

function newchangeResultsSetCampaign(service, id, price, taxprice, type, planname) {
    var servicejp = "";
    if (service === "net") {
        servicejp = "ネット";
    } else if (service === "mobile") {
        servicejp = "モバイル";
    } else if (service === "tv") {
        servicejp = "テレビ";
    } else if (service === "phone") {
        servicejp = "固定電話";
    }

    $('.table-' + type + '-' + service + '-price').empty();

    var step31 = $('input[type="checkbox"][name="step3-1-' + service + '"]:checked').length > 0;
    var step32 = $('input[type="checkbox"][name="step3-2-' + service + '"]:checked').length > 0;

    var camp_id = "";
    var camp_val = "";
    var months = "";
    var cashbackChecked = false;
    var plan_note = "";
    if (step31) {
        camp_id = $('input[type="checkbox"][name="step3-1-' + service + '"]:checked').data('id');
        camp_val = $('.campaign-' + service + '-discount-h-' + camp_id).val();
        months = $('.campaign-' + service + '-months-h-' + camp_id).val();
        cashbackChecked = $('input[type="checkbox"][name="step3-1-cb-' + service + '"]').is(':checked');
        plan_note = $('.' + service + '-note-h-' + id).val();


    } else if (step32) {
        camp_id = $('input[type="checkbox"][name="step3-2-' + service + '"]:checked').data('id');
        camp_val = $('.campaign-' + service + '-discount-m-' + camp_id).val();
        months = $('.campaign-' + service + '-months-m-' + camp_id).val();
        cashbackChecked = $('input[type="checkbox"][name="step3-2-cb-' + service + '"]').is(':checked');
        plan_note = $('.' + service + '-note-m-' + id).val();

    }

    if (step31 || step32) {
        $('.res-campaign').show();
        var camp_discount = txtToNumber(price) - txtToNumber(camp_val);

        var taxdiscount = camp_discount * 0.1 + camp_discount;

        var price500 = false;
        if (service === "tv") {
            if (planname == "シン・スタンダード" || planname == "フレックスA/B with Netflix") {
                price500 = true;

                $('.table-' + type + '-' + service + '-price').append(`
                    <div class="res-with-campaign">
                        <div class="res-with-campaign__normalprice">
                            <p><strong>${price}</strong>円</p>
                            <p><span>(税込${numberToTxt(taxprice)}円)</span></p>
                        </div>
                        <div class="res-with-campaign__campprice">
                            <div class="res-with-campaign__discount --highlight">
                                <p class="res-with-campaign__discount-txt">
                                    <span class="txt-med">${months}ヶ月月額</span>
                                    <span class="res-with-campaign__discount-price">500</span>
                                    <span>円(税込)</span>
                                </p>
                                <span class="highlight-span"></span>
                            </div>
                            <p class="res-with-campaign__taxdiscount">(割引終了後：税込${numberToTxt(taxprice)}円)</p>
                        </div>
                    </div>
                `);
            }
        }
        var price0 = false;
        if (service === "net") {

            if (cashbackChecked) {
                price0 = true;
                $('.jisshitsu-notes').empty();


                var jisshitsu = "実質";
                if ($('input[type="radio"][name="step2"]:checked').val().trim() === "集合住宅") {
                    jisshitsu = "";
                    $('.jisshitsu-notes').hide();
                } else {
                    $('.jisshitsu-notes').show();

                }

                $('.table-' + type + '-' + service + '-price').append(`
                    <div class="res-with-campaign">
                        <div class="res-with-campaign__normalprice">
                            <p><strong>${price}</strong>円</p>
                            <p><span>(税込${numberToTxt(taxprice)}円)</span></p>
                        </div>
                        <div class="res-with-campaign__campprice">
                            <div class="res-with-campaign__discount --highlight">
                                <p class="res-with-campaign__discount-txt">
                                    <span class="txt-med">${months}ヶ月${jisshitsu}月額</span>
                                    <span class="res-with-campaign__discount-price">0</span>
                                    <span>円<sup>※1</sup></span>
                                </p>
                                <span class="highlight-span"></span>
                            </div>
                            <p class="res-with-campaign__taxdiscount">(割引終了後：税込${numberToTxt(taxprice)}円)</p>
                        </div>
                    </div>
                    
                `);

                $('.jisshitsu-notes').append(`<p class="text notes">${plan_note}</p>`);

            }
        }

        if (!price500 && !price0) {
            $('.table-' + type + '-' + service + '-price').append(`
                <div class="res-with-campaign">
                    <div class="res-with-campaign__normalprice">
                        <p><strong>${price}</strong>円</p>
                        <p><span>(税込${numberToTxt(taxprice)}円)</span></p>
                    </div>
                    <div class="res-with-campaign__campprice">
                        <div class="res-with-campaign__discount --highlight">
                            <p class="res-with-campaign__discount-txt">
                                <span class="txt-med">${months}ヶ月月額</span>
                                <span class="res-with-campaign__discount-price">${numberToTxt(camp_discount)}</span>
                                <span>円(税込)</span>
                            </p>
                            <span class="highlight-span"></span>
                        </div>
                        <p class="res-with-campaign__taxdiscount">(割引終了後：税込${numberToTxt(taxprice)}円)</p>
                    </div>
                </div>
            `);
        }

    } else {
        $('.table-' + type + '-' + service + '-price').append(`
            <div class="res-with-campaign">
                <div class="res-with-campaign__campprice">
                    <div class="res-with-campaign__discount">
                        <p class="res-with-campaign__discount-price">${price}円</p>
                    </div>
                    <p class="res-with-campaign__taxdiscount">(税込${numberToTxt(taxprice)}円)</p>
                </div>
            </div>
        `);


    }

}

// ご利用中のお客様
function showhideResultschange(step, service) {
    var nashi = false;
    if ($('input[type="radio"][name="' + step + '-' + service + '-h"]:checked').val() === "なし") {
        nashi = true;
    } else if ($('input[type="radio"][name="' + step + '-' + service + '-m"]:checked').val() === "なし") {
        nashi = true;
    }

    if (nashi) {
        $('.row-change-' + service).removeClass('active-row');
        $('.row-current-' + service).addClass('active-row');

        if (step === "stepchange") {
            $('.row-current-res-' + service).removeClass('active-row');
        }
    }
}

function initTableResults() {
    $('.table-new').removeClass('step-active');
    $('.table-change').removeClass('step-active');
    $('.table__row').removeClass('active-row');

}

function getSelectedResults() {
    var step = "step";
    if ($('input[type="radio"][name="step1"]:checked').val().trim() === "ご利用中のお客さま") {
        step = "stepcur";
    }
    $('#res-net').empty();
    $('.res-others-net').empty();
    if ($('#cbNet').is(':checked') || $('#cbNet-cur2').is(':checked')) {
        selectedResultsCalc('net', step);
    }

    $('#res-mobile').empty();
    $('.res-others-mobile').empty();
    if ($('#cbMobile').is(':checked') || $('#cbMobile-cur2').is(':checked')) {
        selectedResultsCalc('mobile', step);
    }

    $('#res-tv').empty();
    $('.res-others-tv').empty();
    if ($('#cbTv').is(':checked') || $('#cbTv-cur2').is(':checked')) {
        selectedResultsCalc('tv', step);
    }

    $('#res-phone').empty();
    $('.res-others-phone').empty();
    if ($('#cbPhone').is(':checked') || $('#cbPhone-cur2').is(':checked')) {
        selectedResultsCalc('phone', step);
    }
}

// show ご検討中のお客様 results
function selectedResultsCalc(service, step) {
    var servicejp = "";
    if (service === "net") {
        servicejp = "ネット";
    } else if (service === "mobile") {
        servicejp = "モバイル";
    } else if (service === "tv") {
        servicejp = "テレビ";
    } else if (service === "phone") {
        servicejp = "固定電話";
    }

    let step2_val = $('input[name="step2"]:checked').val();
    if (step2_val === "戸建住宅") {
        if ($('input[type="radio"][name="' + step + '-' + service + '-h"]:checked').length > 0) {
            var id = $('input[type="radio"][name="' + step + '-' + service + '-h"]:checked').data('id');
            var price = $('.' + service + '-price-h-' + id).val();
            var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);
            var plan_note = $('.' + service + '-note-h-' + id).val();;


            if ($('input[type="checkbox"][name="step3-1-' + service + '"]:checked').length > 0) {
                $('.res-campaign').show();
                var camp_id = $('input[type="checkbox"][name="step3-1-' + service + '"]:checked').data('id');
                var camp_val = $('.campaign-' + service + '-discount-h-' + camp_id).val();
                var months = $('.campaign-' + service + '-months-h-' + camp_id).val();
                var camp_discount = txtToNumber(price) - txtToNumber(camp_val);

                var taxdiscount = camp_discount * 0.1 + camp_discount;


                var price500 = false;
                if (service === "tv") {

                    var plan = $('input[type="radio"][name="' + step + '-' + service + '-h"]:checked').val().trim();
                    if (plan == "シン・スタンダード" || plan == "フレックスA/B with Netflix") {
                        price500 = true;


                        $('#res-' + service + '').append(`
                            <div class="aic-simulator__results-service">
                                <p class="aic-simulator__results-service__name">${servicejp}</p>
                                <div class="res-with-campaign">
                                    <div class="res-with-campaign__normalprice">
                                        <p><strong>${price}</strong>円</p>
                                        <p><span>(税込${numberToTxt(taxprice)}円)</span></p>
                    
                                    </div>
                                    <div class="res-with-campaign__campprice">
                                        <div class="res-with-campaign__discount --highlight">
                                            <p class="res-with-campaign__discount-txt">
                                                <span class="txt-med">${months}ヶ月月額</span>
                                                <span class="res-with-campaign__discount-price">500</span>
                                                <span>円(税込)</span>
                                            </p>
                                            <span class="highlight-span"></span>
                                        </div>
                                        <p class="res-with-campaign__taxdiscount">(割引終了後：税込${numberToTxt(taxprice)}円)</p>
                                    </div>
                                </div>
                    
                            </div>
                        `);
                    }
                }

                var price0 = false;
                if (service === "net") {

                    $('.jisshitsu-notes').empty();
                    if ($('input[type="checkbox"][name="step3-1-cb-' + service + '"]').is(':checked')) {
                        price0 = true;


                        var plan = $('input[type="radio"][name="' + step + '-' + service + '-h"]:checked').val().trim();

                        $('#res-' + service + '').append(`
                            <div class="aic-simulator__results-service">
                                <p class="aic-simulator__results-service__name">${servicejp}</p>
                                <div class="res-with-campaign">
                                    <div class="res-with-campaign__normalprice">
                                        <p><strong>${price}</strong>円</p>
                                        <p><span>(税込${numberToTxt(taxprice)}円)</span></p>
                    
                                    </div>
                                    <div class="res-with-campaign__campprice">
                                        <div class="res-with-campaign__discount --highlight">
                                            <p class="res-with-campaign__discount-txt">
                                                <span class="txt-med">${months}ヶ月実質月額</span>
                                                <span class="res-with-campaign__discount-price">0</span>
                                                <span>円<sup>※1</sup></span>
                                            </p>
                                            <span class="highlight-span"></span>
                                        </div>
                                        <p class="res-with-campaign__taxdiscount">(割引終了後：税込${numberToTxt(taxprice)}円)</p>
                                    </div>
                                </div>
                    
                            </div>
                        `);

                        $('.jisshitsu-notes').append(`<p class="text notes">${plan_note}</p>`);
                    }
                }

                if (!price500 && !price0) {
                    $('#res-' + service + '').append(`
                        <div class="aic-simulator__results-service">
                            <p class="aic-simulator__results-service__name">${servicejp}</p>
                            <div class="res-with-campaign">
                                <div class="res-with-campaign__normalprice">
                                    <p><strong>${price}</strong>円</p>
                                    <p><span>(税込${numberToTxt(taxprice)}円)</span></p>
                
                                </div>
                                <div class="res-with-campaign__campprice">
                                    <div class="res-with-campaign__discount --highlight">
                                        <p class="res-with-campaign__discount-txt">
                                            <span class="txt-med">${months}ヶ月月額</span>
                                            <span class="res-with-campaign__discount-price">${numberToTxt(camp_discount)}</span>
                                            <span>円(税抜)</span>
                                        </p>
                                        <span class="highlight-span"></span>
                                    </div>
                                    <p class="res-with-campaign__taxdiscount">(割引終了後：税込${numberToTxt(taxprice)}円)</p>
                                </div>
                            </div>
                
                        </div>
                    `);
                }

            } else {
                $('#res-' + service + '').append(`
                    <div class="aic-simulator__results-service">
                        <p class="aic-simulator__results-service__name">${servicejp}</p>
                        <div class="res-with-campaign">
                            <div class="res-with-campaign__campprice">
                                <div class="res-with-campaign__discount">
                                    <p class="res-with-campaign__discount-price">${price}円</p>
                                </div>
                                <p class="res-with-campaign__taxdiscount">(税込${numberToTxt(taxprice)}円)</p>
                            </div>
                        </div>
            
                    </div>
                `);
            }

            if ($('input[type="checkbox"][name="step3-1-cb-' + service + '"]:checked').length > 0) {
                $('.res-other').addClass('step-active');
                var cashback_id = $('input[type="checkbox"][name="step3-1-cb-' + service + '"]:checked').data('id');
                var cashback_name = $('input[type="checkbox"][name="step3-1-cb-' + service + '"]:checked').data('cbname');
                var cashback_val = $('.cashback-' + service + '-value-h-' + cashback_id).val();

                $('.res-others-' + service).append(`
                    <p><span class="med-txt">${cashback_name}</span></p>
                    <p>キャッシュバック <span class="big-txt">${cashback_val}</span>円分</p>
                `);
            } else {
                isAnyOtherSelected();
            }

            // set 追加オプション in results
            if ($('input[type="radio"][name="' + step + '-mobileoption-h"]').is(':checked')) {
                item = $('input[type="radio"][name="' + step + '-mobileoption-h"]:checked').data("id");
                mobileopprice = txtToNumber($('.mobileoption-price-h-' + item).val());
                mobileoptaxprice = mobileopprice * 0.1 + mobileopprice;

                mobileopprice_cur = mobileopprice;
                mobileoptaxprice_cur = mobileoptaxprice;
                $('.table-current-mobileoption').text($('input[type="radio"][name="' + step + '-mobileoption-h"]:checked').val());
                $('.table-price-current-mobileoption').text(numberToTxt(mobileopprice));
                $('.table-taxprice-current-mobileoption').text(numberToTxt(mobileoptaxprice));
            }
        }


    } else if (step2_val === "集合住宅") {

        if ($('input[type="radio"][name="' + step + '-' + service + '-m"]:checked').length > 0) {
            var id = $('input[type="radio"][name="' + step + '-' + service + '-m"]:checked').data('id');
            var price = $('.' + service + '-price-m-' + id).val();
            var taxprice = txtToNumber(price) * 0.1 + txtToNumber(price);
            var plan_note = $('.' + service + '-note-m-' + id).val();;

            if ($('input[type="checkbox"][name="step3-2-' + service + '"]:checked').length > 0) {
                $('.res-campaign').show();
                var camp_id = $('input[type="checkbox"][name="step3-2-' + service + '"]:checked').data('id');
                var camp_val = $('.campaign-' + service + '-discount-m-' + camp_id).val();
                var months = $('.campaign-' + service + '-months-m-' + camp_id).val();
                var camp_discount = txtToNumber(price) - txtToNumber(camp_val);

                var taxdiscount = camp_discount * 0.1 + camp_discount;

                var price500 = false;
                if (service === "tv") {
                    var plan = $('input[type="radio"][name="' + step + '-' + service + '-m"]:checked').val().trim();

                    if (plan == "シン・スタンダード" || plan == "フレックスA/B with Netflix") {
                        price500 = true;

                        $('#res-' + service + '').append(`
                            <div class="aic-simulator__results-service">
                                <p class="aic-simulator__results-service__name">${servicejp}</p>
                                <div class="res-with-campaign">
                                    <div class="res-with-campaign__normalprice">
                                        <p><strong>${price}</strong>円</p>
                                        <p><span>(税込${numberToTxt(taxprice)}円)</span></p>
                    
                                    </div>
                                    <div class="res-with-campaign__campprice">
                                        <div class="res-with-campaign__discount --highlight">
                                            <p class="res-with-campaign__discount-txt">
                                                <span class="txt-med">${months}ヶ月月額</span>
                                                <span class="res-with-campaign__discount-price">500</span>
                                                <span>円(税込)</span>
                                            </p>
                                            <span class="highlight-span"></span>
                                        </div>
                                        <p class="res-with-campaign__taxdiscount">(割引終了後：税込${numberToTxt(taxprice)}円)</p>
                                    </div>
                                </div>
                    
                            </div>
                        `);
                    }
                }

                var price0 = false;
                if (service === "net") {

                    if ($('input[type="checkbox"][name="step3-2-cb-' + service + '"]').is(':checked')) {
                        price0 = true;

                        var plan = $('input[type="radio"][name="' + step + '-' + service + '-m"]:checked').val().trim();

                        $('#res-' + service + '').append(`
                            <div class="aic-simulator__results-service">
                                <p class="aic-simulator__results-service__name">${servicejp}</p>
                                <div class="res-with-campaign">
                                    <div class="res-with-campaign__normalprice">
                                        <p><strong>${price}</strong>円</p>
                                        <p><span>(税込${numberToTxt(taxprice)}円)</span></p>
                    
                                    </div>
                                    <div class="res-with-campaign__campprice">
                                        <div class="res-with-campaign__discount --highlight">
                                            <p class="res-with-campaign__discount-txt">
                                                <span class="txt-med">${months}ヶ月月額</span>
                                                <span class="res-with-campaign__discount-price">0</span>
                                                <span>円</span>
                                            </p>
                                            <span class="highlight-span"></span>
                                        </div>
                                        <p class="res-with-campaign__taxdiscount">(割引終了後：税込${numberToTxt(taxprice)}円)</p>
                                    </div>
                                </div>
                                
                            </div>
                        `);
                    }
                }

                if (!price500 && !price0) {
                    $('#res-' + service + '').append(`
                        <div class="aic-simulator__results-service">
                            <p class="aic-simulator__results-service__name">${servicejp}</p>
                            <div class="res-with-campaign">
                                <div class="res-with-campaign__normalprice">
                                    <p><strong>${price}</strong>円</p>
                                    <p><span>(税込${numberToTxt(taxprice)}円)</span></p>
                
                                </div>
                                <div class="res-with-campaign__campprice">
                                    <div class="res-with-campaign__discount --highlight">
                                        <p class="res-with-campaign__discount-txt">
                                            <span class="txt-med">${months}ヶ月月額</span>
                                            <span class="res-with-campaign__discount-price">${numberToTxt(camp_discount)}</span>
                                            <span>円(税抜)</span>
                                        </p>
                                        <span class="highlight-span"></span>
                                    </div>
                                    <p class="res-with-campaign__taxdiscount">(割引終了後：税込${numberToTxt(taxprice)}円)</p>
                                </div>
                            </div>
                
                        </div>
                    `);
                }

            } else {
                $('#res-' + service + '').append(`
                <div class="aic-simulator__results-service">
                    <p class="aic-simulator__results-service__name">${servicejp}</p>
                    <div class="res-with-campaign">
                        <div class="res-with-campaign__campprice">
                            <div class="res-with-campaign__discount">
                                <p class="res-with-campaign__discount-price">${price}円</p>
                            </div>
                            <p class="res-with-campaign__taxdiscount">(税込${numberToTxt(taxprice)}円)</p>
                        </div>
                    </div>
        
                </div>
            `);
            }

            if ($('input[type="checkbox"][name="step3-2-cb-' + service + '"]:checked').length > 0) {
                $('.res-other').addClass('step-active');
                var cashback_id = $('input[type="checkbox"][name="step3-2-cb-' + service + '"]:checked').data('id');
                var cashback_name = $('input[type="checkbox"][name="step3-2-cb-' + service + '"]:checked').data('cbname');
                var cashback_val = $('.cashback-' + service + '-value-m-' + cashback_id).val();

                $('.res-others-' + service).append(`
                <p><span class="med-txt">${cashback_name}</span></p>
                <p>キャッシュバック <span class="big-txt">${cashback_val}</span>円分</p>
            `);
            } else {
                isAnyOtherSelected();
            }

            // set 追加オプション in results
            if ($('input[type="radio"][name="' + step + '-mobileoption-m"]').is(':checked')) {
                item = $('input[type="radio"][name="' + step + '-mobileoption-m"]:checked').data("id");
                mobileopprice = txtToNumber($('.mobileoption-price-m-' + item).val());
                mobileoptaxprice = mobileopprice * 0.1 + mobileopprice;

                mobileopprice_cur = mobileopprice;
                mobileoptaxprice_cur = mobileoptaxprice;
                $('.table-current-mobileoption').text($('input[type="radio"][name="' + step + '-mobileoption-m"]:checked').val());
                $('.table-price-current-mobileoption').text(numberToTxt(mobileopprice));
                $('.table-taxprice-current-mobileoption').text(numberToTxt(mobileoptaxprice));
            }
        }

    }
}

function isAnyOtherSelected() {
    let step2_val = $('input[name="step2"]:checked').val();
    if (step2_val === "戸建住宅") {
        var isNetOtherChecked = $('input[type="checkbox"][name="step3-1-cb-net"]:checked').length > 0;
        var isMobileOtherChecked = $('input[type="checkbox"][name="step3-1-cb-mobile"]:checked').length > 0;
        var isTvOtherChecked = $('input[type="checkbox"][name="step3-1-cb-tv"]:checked').length > 0;
        var isPhoneOtherChecked = $('input[type="checkbox"][name="step3-1-cb-phone"]:checked').length > 0;

        if (isNetOtherChecked || isMobileOtherChecked || isTvOtherChecked || isPhoneOtherChecked) {
            $('.res-other').addClass('step-active');
        } else {
            $('.res-other').removeClass('step-active');
        }
    } else if (step2_val === "集合住宅") {
        var isNetOtherChecked = $('input[type="checkbox"][name="step3-2-cb-net"]:checked').length > 0;
        var isMobileOtherChecked = $('input[type="checkbox"][name="step3-2-cb-mobile"]:checked').length > 0;
        var isTvOtherChecked = $('input[type="checkbox"][name="step3-2-cb-tv"]:checked').length > 0;
        var isPhoneOtherChecked = $('input[type="checkbox"][name="step3-2-cb-phone"]:checked').length > 0;

        if (isNetOtherChecked || isMobileOtherChecked || isTvOtherChecked || isPhoneOtherChecked) {
            $('.res-other').addClass('step-active');
        } else {
            $('.res-other').removeClass('step-active');
        }
    }
}

function initResults() {
    $('#res-net').empty();
    $('#res-mobile').empty();
    $('#res-tv').empty();
    $('#res-phone').empty();
}

// ------------------------------
// Accordion
// ------------------------------
$(document).ready(function () {
    // ボタンがクリックされたときの処理
    $('.aic-mobile-btn').on('click', function () {
        // クリックされたボタンの親要素に対して.activeクラスを付ける
        $(this).closest('.aic-mobile-accordion').toggleClass('active');
        // アコーディオンの内容部分をスライドで表示・非表示する
        $(this).closest('.aic-mobile-accordion').find('.accordion__body').slideToggle();
    });

    // ボタンがクリックされたときの処理
    $('.aic-cashback-btn').on('click', function () {
        // クリックされたボタンの親要素に対して.activeクラスを付ける
        $(this).closest('.aic-cashback-accordion').toggleClass('active');
        // アコーディオンの内容部分をスライドで表示・非表示する
        $(this).closest('.aic-cashback-accordion').find('.accordion__body').slideToggle();
    });
});

// ------------------------------
// Generate PDF
// ------------------------------
$(document).ready(function () {
    const { jsPDF } = window.jspdf;

    $(document).on('click', '#generate-graphic-pdf', function () {

        html2canvas(document.querySelector("#step-res1"), {
            windowWidth: 1200,
        }).then(canvas => {
            // convert canvas to base64 image
            var imgData = canvas.toDataURL('image/png');

            // new pdf
            var doc = new jsPDF();

            // get pdf dimensions
            var pdfWidth = doc.internal.pageSize.getWidth();
            var pdfHeight = doc.internal.pageSize.getHeight();

            // get images dimensions (original proportion)
            var imgWidth = canvas.width;
            var imgHeight = canvas.height;

            // calculate original proportion
            var ratio = imgWidth / imgHeight;

            // set margim
            var margin = 24;

            // calculate new width and height based on PDF width
            var newWidth = pdfWidth - 2 * margin;
            var newHeight = newWidth / ratio;

            // If the adjusted height is greater than the PDF height, we adjust the height
            if (newHeight > pdfHeight - 2 * margin) {
                newHeight = pdfHeight - 2 * margin;
                newWidth = newHeight * ratio;
            }

            // calculate x position to center image
            var xPos = margin;

            // calculate x position to center image
            var yPos = margin;

            // add image to PDF with new dimensions
            doc.addImage(imgData, 'PNG', xPos, yPos, newWidth, newHeight);

            // save PDF
            doc.save('simulation_results.pdf');
        }).catch(error => {
            console.error('PDF error:', error);
        });
    });

    $(document).on('click', '#generate-table-pdf', function () {

        html2canvas(document.querySelector("#step-res3"), {
            windowWidth: 1200,
        }).then(canvas => {
            // convert canvas to base64 image
            var imgData = canvas.toDataURL('image/png');

            // new pdf
            var doc = new jsPDF();

            // get pdf dimensions
            var pdfWidth = doc.internal.pageSize.getWidth();
            var pdfHeight = doc.internal.pageSize.getHeight();

            // get images dimensions (original proportion)
            var imgWidth = canvas.width;
            var imgHeight = canvas.height;

            // calculate original proportion
            var ratio = imgWidth / imgHeight;

            // set margim
            var margin = 24;

            // calculate new width and height based on PDF width
            var newWidth = pdfWidth - 2 * margin;
            var newHeight = newWidth / ratio;

            // If the adjusted height is greater than the PDF height, we adjust the height
            if (newHeight > pdfHeight - 2 * margin) {
                newHeight = pdfHeight - 2 * margin;
                newWidth = newHeight * ratio;
            }

            // calculate x position to center image
            var xPos = margin;

            // calculate x position to center image
            var yPos = margin;

            // add image to PDF with new dimensions
            doc.addImage(imgData, 'PNG', xPos, yPos, newWidth, newHeight);

            // save PDF
            doc.save('simulation_results.pdf');
        }).catch(error => {
            console.error('PDF error:', error);
        });
    });
});